import { useStore } from './store';

/* English is the source; Arabic must define every key (the compiler enforces it).
   Values may contain {name} placeholders filled by fmt(). */
const en = {
  'brand.name': 'digital marshal',
  'brand.sub': 'Autonomous Mobility Intelligence Platform',
  'brand.tagline': 'See the road before it happens',
  'chip.prototype': 'Synthetic research prototype',
  'chip.prototype.title':
    'Independent student prototype. Synthetic Dubai-inspired district; no RTA systems, data or endorsement.',
  'view.twin': 'Digital twin',
  'view.compare': 'Evidence',
  'view.engineering': 'Engineering',
  'view.about': 'About',
  'lang.toggle': 'العربية',
  'lang.toggle.label': 'Switch language to Arabic',
  'status.running': 'Running',
  'status.paused': 'Paused',
  'status.scenario': 'Scenario',
  'scenario.normal': 'Normal operations',
  'panel.ops': 'Operations',
  'panel.intel': 'Intelligence',
  'panel.collapse': 'Collapse panel',
  'panel.expand.ops': 'Show operations panel',
  'panel.expand.intel': 'Show intelligence panel',
  'panel.collapse.ops': 'Collapse operations panel',
  'panel.collapse.intel': 'Collapse intelligence panel',
  'a11y.skip': 'Skip to main content',
  'a11y.twin': 'Digital twin of the district',
  'a11y.stage':
    '3D city view. Drag to orbit, right-drag or shift-drag to pan, scroll to zoom. Arrow keys orbit, plus and minus zoom, Home resets the camera.',
  'nav.views': 'Views',
  'keys.toggle': 'Single-key shortcuts',
  'keys.note': '1–7 camera modes, W A S D move the camera (Q E turn, R F zoom, hold Shift to go faster), [ and ] panels, Space play or pause, Shift+P performance. Turn them off if they clash with speech input or other assistive technology.',
  'cam.overview': 'City overview',
  'cam.topdown': 'Top-down',
  'cam.incident': 'Incident focus',
  'cam.follow': 'Vehicle follow',
  'cam.emergency': 'Emergency follow',
  'cam.street': 'Street view',
  'cam.free': 'Free camera',
  'cam.wasd': 'Hold W A S D to fly the camera (Q E turn, R F zoom, Shift faster)',
  'cam.reset': 'Reset camera',
  'cam.toolbar': 'Camera modes',
  'play.play': 'Play',
  'play.pause': 'Pause',
  'play.restart': 'Restart',
  'play.speed': 'Playback speed',
  'play.scrub': 'Simulation timeline',
  'play.next': 'Jump to next important event',
  'play.time': 'Simulation time',
  'play.ahead': 'Simulating ahead',
  'gfx.title': 'Graphics',
  'gfx.auto': 'Auto',
  'gfx.high': 'High',
  'gfx.balanced': 'Balanced',
  'gfx.performance': 'Performance',
  'gfx.perf': 'Performance monitor',
  'gfx.downgraded': 'Graphics lowered to {q} to keep the simulation smooth.',
  'perf.fps': 'FPS',
  'perf.close': 'Close performance overlay',
  'perf.frame': 'Frame time',
  'perf.calls': 'Draw calls',
  'perf.tris': 'Triangles',
  'perf.geo': 'Geometries',
  'perf.tex': 'Textures',
  'perf.sim': 'Sim step',
  'perf.quality': 'Quality',
  'perf.pr': 'Pixel ratio',
  'nowebgl.title': 'WebGL is not available',
  'nowebgl.body':
    'This browser or device cannot create a WebGL context, so the 3D city cannot be drawn. The simulation still runs, and this 2D map shows the same live state.',
  'nowebgl.map': '2D map of the district: roads, junctions (dark ones in red), closures and every vehicle',
  'loading': 'Preparing the district',
  'display.title': 'Display',
  'display.labels': 'Junction labels',
  'display.v2x': 'Information-flow overlays',
  'display.routes': 'Vehicle routes',
  'intel.network': 'Network',
  'intel.pending': 'The traffic simulation attaches in the next milestone. Camera, graphics tiers and views are live.',
  'caption.district': 'Synthetic Dubai-inspired urban district',
  'caption.district.sub': 'Invented layout · road names are codes · not real streets',
  'lbl.ev.free': 'Corridor clear',
  'lbl.ev.leader': 'Vehicle ahead',
  'lbl.ev.signal': 'Signal ahead',
  'lbl.ev.junction': 'Crossing a junction',
  'lbl.ev.arrive': 'Arriving',
  'lbl.ev.arrived': 'On scene',
  'lbl.ev.speed': '{n} km/h',
  'lbl.dark': 'Signal offline',
  'lbl.works.lane': 'Lane closed',
  'lbl.works.full': 'Road closed',
  'lbl.works.planned': 'Closure published',
  'tod.title': 'Lighting',
  'tod.day': 'Midday',
  'tod.golden': 'Golden hour',
  'tod.dusk': 'Dusk',
  'tod.night': 'Night',
  'tod.note': 'Lighting only: the simulation and its results do not change.',
  'map.title': 'District map',
  'map.zoomIn': 'Zoom the map in',
  'map.zoomOut': 'Zoom the map out',
  'map.locate': 'Centre the map on the camera',
  'map.hint': 'Click the map to move the camera there',
  'load.kit': 'Loading the 3D district',
  'load.build': 'Building the district',
  'load.note': 'Synthetic Dubai-inspired district · independent student research prototype · not an RTA system',
  'sim.title': 'Simulation',
  'sim.density': 'Traffic demand',
  'sim.densityValue': '{pct}% of the reference evening demand',
  'sim.seed': 'Seed',
  'sim.densityNote': 'Applies from now on and is recorded, so replays reproduce it.',
  'intel.active': 'Vehicles in district',
  'intel.moving': 'Moving',
  'intel.stopped': 'Stopped',
  'intel.atSignals': 'at signals',
  'intel.speed': 'Mean speed',
  'intel.trips': 'Trips completed',
  'intel.delay': 'Mean delay per trip',
  'intel.mix': 'Fleet mix',
  'intel.stoppedSeries': 'Stopped vehicles, last 6 min',
  'intel.hint': 'Click any vehicle in the city to inspect what it is doing and why.',
  'intel.nearMiss': 'Emergency stops at junction entry',
  'intel.queued': 'Waiting to enter at the edge',
  'cls.robotaxi': 'Robotaxi (simulated AV)',
  'cls.car': 'Private car',
  'cls.van': 'Delivery van',
  'cls.bus': 'Bus',
  'cls.ambulance': 'Ambulance',
  'veh.identity': 'Identity',
  'veh.motion': 'Motion',
  'veh.route': 'Route',
  'veh.planning': 'Planning: why it is doing this',
  'veh.timeline': 'Decision timeline',
  'veh.autonomy': 'Autonomy',
  'veh.autonomy.av': 'Simulated autonomous planner (research model, not a certified system)',
  'veh.autonomy.human': 'Human driver model',
  'veh.connected': 'V2X connected',
  'veh.notConnected': 'Not connected',
  'veh.speed': 'Speed',
  'veh.accel': 'Acceleration',
  'veh.road': 'Road',
  'veh.lane': 'Lane',
  'veh.laneOf': '{lane} of {lanes}',
  'veh.from': 'From',
  'veh.to': 'To',
  'veh.remaining': 'Remaining',
  'veh.inDistrict': 'Time in district',
  'veh.stoppedFor': 'Time stopped',
  'veh.reroutes': 'Re-routes',
  'veh.laneChanges': 'Lane changes',
  'veh.follow': 'Follow',
  'veh.close': 'Close inspector',
  'veh.exited': 'This vehicle has left the district. Last known state shown.',
  'veh.mode.drive': 'Driving',
  'veh.mode.mrc': 'Minimal risk condition',
  'veh.mode.arrived': 'Arrived',
  'bind.free': 'Driving at the desired speed; nothing ahead constrains it.',
  'bind.leader': 'Following {ref}, {gap} m ahead.',
  'bind.signal.stop': 'Stopped at a red signal at {ref}. Its movement turns green in {extra} s.',
  'bind.signal.slow': 'Slowing for a red signal at {ref}, {gap} m to the stop line.',
  'bind.awsc.self': 'Signals at {ref} are dark. It treats the junction as an all-way stop and must stop at the line first.',
  'bind.awsc.other': 'All-way stop: waiting for {ref}, which stopped first and has a conflicting path.',
  'bind.box': 'Junction box occupied by {ref} on a conflicting path; waiting for it to clear.',
  'bind.exit': 'Exit lane is full beyond the junction ({ref}); not entering so the box stays clear.',
  'bind.curve': 'Slowing to a safe turning speed for the junction at {ref}.',
  'bind.closure': 'Physical closure ahead ({ref}); stopping or merging around it.',
  'bind.mrc': 'Stopped safely before {ref}: an uncontrolled junction this wide is outside the vehicle\u2019s operating domain. It waits for remote assistance and never crosses on its own.',
  'bind.yield': 'Yielding to an emergency vehicle.',
  'bind.lanechange': 'Waiting for a safe gap to reach the lane it needs.',
  'bind.arrive': 'Arriving at its destination.',
  'veh.onScene': 'On scene: pulled in at the kerb by its call, beacons on.',
  'bind.spawn': 'Waiting to enter the district.',
  'log.SPAWN': 'Entered the district at {from}',
  'log.ROUTE': 'Planned a route of {links} links (free-flow {ff} s)',
  'log.REROUTE': 'Re-routed ({reason}) via {via}',
  'log.STOP_SIGNAL': 'Stopping for red at {junction}',
  'log.GO_SIGNAL': 'Green at {junction}: proceeding',
  'log.AMBER_COMMIT': 'Amber at {junction} but too close to stop: committed',
  'log.AWSC_STOP': 'Stopped at dark junction {junction} (all-way stop)',
  'log.AWSC_GO': 'Its turn at {junction}: crossing',
  'log.LANE_CHANGE': 'Changed lane {from} \u2192 {to} ({reason})',
  'log.MISSED_TURN': 'No safe gap to reach its turn lane; took another exit and re-planned',
  'log.BOX_WAIT': 'Waited for the junction box to clear',
  'log.EXIT_WAIT': 'Waited: exit lane full',
  'log.MRC': 'Minimal risk stop at {junction} (outside operating domain, {lanes}-lane approach)',
  'log.ASSIST_REQUEST': 'Requested remote assistance',
  'log.ASSIST_GRANTED': 'Released from minimal risk stop ({by})',
  'log.YIELD': 'Moved to lane {to} to let {ev} pass ({via})',
  'log.YIELD_INFEASIBLE': 'Could not yield to {ev} safely: {reason}',
  'log.MSG_RX': 'Received message {msg}',
  'log.MSG_REJECT': 'Rejected message {msg}: {reason}',
  'log.CLOSURE_SEEN': 'Saw the closure at {where}',
  'log.ARRIVED': 'Arrived at {place}',
  'log.EXITED': 'Left the district at {at}',
  'log.NO_ALTERNATIVE': 'No feasible alternative route ({reason}); keeping its plan',
  'log.ADVICE': 'Adopted coordinated detour advice via {via}',

  'scn.title': 'Scenario',
  'scn.normal': 'Normal operations',
  'scn.normal.d': 'Evening traffic with all signals working. The baseline every scenario starts from.',
  'scn.blackout': '01 Signal blackout',
  'scn.blackout.d': 'Signal controllers lose power. AVs apply their own dark-signal rules; the city shares the outage and coordinates exceptions.',
  'scn.emergency': '02 Emergency vehicle',
  'scn.emergency.d': 'An ambulance crosses the district. Vehicles evaluate safe yielding; infeasible yields are reported, not forced.',
  'scn.roadworks': '05 Roadworks',
  'scn.roadworks.d': 'Lane and segment closures are published, validated and routed around, including stale and invalid updates.',
  'bo.junctions': 'Junctions that lose power',
  'bo.restoreAfter': 'Power returns after',
  'bo.manual': 'manual',
  'bo.minutes': '{n} min',
  'bo.trigger': 'Trigger blackout',
  'bo.restore': 'Restore power now',
  'bo.note': 'AVs treat dark signals as all-way stops. Approaches wider than {lanes} lanes are outside the simulated AV operating domain: an AV stops safely there and asks its fleet for remote assistance.',
  'bo.active': 'Dark now: {list}',
  'bo.wide': '{n}-lane approaches',
  'bo.darkState': 'without power',
  'bo.legend': 'Amber: selected. Red: without power. Dot: approaches wider than {lanes} lanes.',
  'pol.title': 'Coordination policy',
  'pol.A': 'A  No shared city information',
  'pol.A.d': 'AVs only see the outage with their own sensors. Remote-assistance requests are handled first come, first served.',
  'pol.B': 'B  Validated incident broadcast',
  'pol.B.d': 'Digital Marshal publishes signed incident messages; each AV validates them and responds on its own. Requests first come, first served.',
  'pol.C': 'C  Broadcast + fleet coordination',
  'pol.C.d': 'B plus coordination: requests that share an incident and junction are grouped and prioritised; one junction-scoped authorisation from the fleet desk covers the group; detours are spread by capacity; an approaching ambulance gets signal priority.',
  'pol.assumption': 'Assumption under test (C): the fleet operator accepts a junction-scoped authorisation while the incident lasts. Each AV still applies its own all-way-stop and gap checks.',
  'pol.replay': 'Switching replays this run from the start with the same seed and triggers.',
  'comms.title': 'Communications (fault injection)',
  'comms.loss': 'Extra packet loss',
  'comms.latency': 'Extra latency',
  'comms.battery': 'RSU battery backup',
  'comms.cell': 'Cellular fallback available',
  'comms.lossValue': '{n}%',
  'comms.latencyValue': '{n} ms',
  'scn.reset': 'Reset scenario',
  'scn.resetNote': 'Clears every trigger and restarts the run.',
  'eng.toggle': 'Engineering parameters',
  'dm.title': 'Digital Marshal',
  'dm.policy': 'Policy',
  'dm.incidents': 'Incidents',
  'dm.none': 'No incidents. The district is operating normally.',
  'dm.exceptions': 'Remote assistance',
  'dm.open': 'waiting',
  'dm.inProgress': 'with an operator',
  'dm.resolved': 'resolved',
  'dm.auto': 'covered by an authorisation',
  'dm.withdrawn': 'withdrawn',
  'dm.operators': 'Operators',
  'dm.idle': 'idle',
  'dm.messages': 'V2X messages',
  'dm.published': 'published',
  'dm.delivered': 'delivered',
  'dm.rejectedN': 'rejected',
  'dm.latency': 'mean latency',
  'dm.mrcNow': 'AVs in minimal risk stop',
  'dm.mrcTime': 'Minimal risk stop time',
  'inc.title': 'Incident',
  'inc.type.signal_outage': 'Signal outage',
  'inc.type.emergency_corridor': 'Emergency corridor',
  'inc.type.roadworks': 'Roadworks',
  'inc.status.active': 'Active',
  'inc.status.resolved': 'Resolved',
  'inc.status.detected': 'Detected',
  'inc.area': 'Affected area',
  'inc.issuer': 'Issuer',
  'inc.version': 'Version',
  'inc.created': 'Opened',
  'inc.resolvedAt': 'Resolved',
  'inc.cause': 'Ground truth',
  'inc.reach': 'Vehicles reached',
  'inc.reachText': '{received} received, {accepted} accepted, {rejected} rejected',
  'inc.queues': 'Stopped on approaches',
  'inc.mrc': 'in minimal risk stop',
  'inc.lifecycle': 'Message lifecycle',
  'inc.exceptions': 'Exceptions at this incident',
  'inc.noExceptions': 'None raised.',
  'inc.close': 'Close incident inspector',
  'inc.focus': 'Point the camera at this incident',
  'inc.notPublished': 'Policy A: detected by the coordination node but not shared with vehicles.',
  'msg.checks': 'Validation checks',
  'msg.injected': 'injected',
  'msg.published': 'published',
  'msg.v.ok': 'Accepted',
  'msg.v.warn': 'Flagged',
  'msg.v.bad': 'Rejected',
  'vdm.title': 'Incident and messages',
  'vdm.none': 'No incident messages received.',
  'vdm.avoid': 'Must avoid (outside its domain): {list}',
  'vdm.auth': 'Authorised to cross {junction} ({scope})',
  'vdm.exceptions': 'Remote assistance requests',
  'vdm.notConnected': 'Not connected: this vehicle only knows what its own sensors see.',
  'feed.title': 'Live events',
  'ev.power-loss': 'Power lost at {junctions}: signals dark',
  'ev.outage-detected': 'Outage detected ({delay} s): incident {ref}',
  'ev.msg-published': 'Published {type} v{version} for {incident}',
  'ev.assist-request': '{ref} stopped at {junction} and asked for assistance',
  'ev.assist-task': 'Operator {operator} took {kind} at {junction} ({n})',
  'ev.assist-granted': 'Operator released a vehicle at {junction}',
  'ev.junction-authorized': '{ref}: fleet authorised all-way stop for {n} vehicle(s)',
  'ev.power-restored': 'Power back at {junctions}',
  'ev.incident-resolved': 'Incident {ref} resolved',
  'ev.advisory-batch': 'Detour allocation sent to {n} vehicles',
  'ev.inject-rejected': 'Injected message rejected: {code}',
  'ev.inject-accepted': 'Injected message accepted ({code})',
  'ev.hard-brake': 'Emergency stop by {ref} at {junction}',
  'ev.box-violation': 'Box violation by {ref}',

  'ev.dispatch': 'Dispatch ambulance',
  'ev.from': 'From',
  'ev.to': 'To',
  'ev.notePolicy': 'Every vehicle yields only when its own gap check passes. Policy B adds early warning by signed corridor messages; policy C also requests signal priority along the route.',
  'ev.active': '{tag} en route',
  'ev.mission': 'Emergency run',
  'ev.dispatchedAt': 'Dispatched',
  'ev.elapsed': 'Elapsed',
  'ev.travel': 'Travel time',
  'ev.ffT': 'Free-flow time on this route',
  'ev.delay': 'Delay',
  'ev.obstructed': 'Held below 80% of its speed',
  'ev.obs.vehicle': 'by vehicles ahead',
  'ev.obs.signal': 'by signals',
  'ev.obs.junction': 'by a busy junction',
  'ev.obs.other': 'other',
  'ev.yields': 'Yield decisions',
  'ev.yieldsText': '{ok} safe yields, {no} infeasible',
  'ev.preempts': 'Signal priority grants',
  'ev.arrived': 'Arrived',
  'ev.route': 'Corridor',
  'ev.follow': 'Follow the ambulance',
  'yield.single_lane_no_shoulder': 'single lane with no shoulder, so there is no safe place to move',
  'yield.held_at_red_signal': 'held at a red signal; it will not enter the junction on red',
  'yield.adjacent_lane_occupied': 'the next lane is occupied ({by}, {gap} m gap): no safe gap',
  'yield.stopped_minimal_risk': 'stopped in a minimal risk condition',
  'log.YIELD.v': 'Moved to lane {to} to let {ev} pass ({via})',
  'ev.ev-dispatched': 'Ambulance {ref} dispatched to {to}',
  'ev.ev-preempt': 'Signal priority at {ref} for {ev}',
  'ev.ev-arrived': '{ref} arrived after {travel} s (free-flow {ff} s)',
  'msg.submitted': 'submitted to the node',
  'hdr.undetected': 'Signal outage (not yet detected)',
  'rw.contractor': 'Contractor',
  'rw.where': 'Location',
  'rw.permit': 'Permit scope',
  'rw.planLane': 'Plan lane closure',
  'rw.escalate': 'Escalate to full closure',
  'rw.lift': 'Works finished',
  'rw.stage.lane': 'lane',
  'rw.stage.full': 'full',
  'rw.what.lane': 'Lane closure',
  'rw.what.full': 'Full closure',
  'rw.pending': '{what} published; cones go out in {n} s',
  'rw.inPlace.lane': 'Lane {lanes} closed from {s0} m to {s1} m',
  'rw.inPlace.full': '{road} closed to all traffic',
  'rw.lifted': 'Works finished: all lanes open',
  'rw.rejected': 'The node refused the contractor submission ({code}); nothing was published',
  'rw.submission': 'Contractor submission',
  'rw.subText': '{code} · {n} checks',
  'rw.audit': 'Safety audit',
  'rw.late': 'Learned of a closure only on sight',
  'rw.restricted': 'Entries into a closed lane',
  'rw.note': 'The contractor signs its plan; the node checks issuer, permission, permit scope and timing, then republishes it ahead of time. Connected vehicles merge early and route around a closed segment. Every vehicle still reacts to the cones it sees.',
  'sec.title': 'Message security tests',
  'sec.intro': 'Each test puts one crafted message on the air. The node and every vehicle that receives it validate it on their own; the row shows what they actually decided.',
  'sec.policyA': 'Policy A has no shared message channel, so there is nothing to inject into. Switch to B or C.',
  'sec.needsIncident': 'Needs a live incident first (for example, plan the lane closure).',
  'sec.inject': 'Inject',
  'sec.injectNamed': 'Inject: {name}',
  'sec.passed': 'Test passed',
  'sec.failed': 'Test failed',
  'sec.expect': 'Expected',
  'sec.node': 'Node',
  'sec.vehicles': 'Vehicles: {rejected} rejected, {flagged} flagged, {accepted} accepted',
  'sec.inflight': 'Delivering to vehicles…',
  'sec.none': 'No vehicle in range received it.',
  'sec.note': 'Tests use the simulated issuers’ demo keys. A valid signature proves who sent a message and that it was not changed, not that it is true. Final movement authority stays with each vehicle.',
  'sec.tampered': 'Tampered message',
  'sec.tampered.d': 'A genuine message altered in transit, here to move the closure onto the open lane.',
  'sec.forged': 'Forged node message',
  'sec.forged.d': 'Claims to come from the coordination node but is signed with another key.',
  'sec.rogue': 'Unknown sender',
  'sec.rogue.d': 'A device outside the trust store announces a boulevard closure.',
  'sec.retired': 'Retired key',
  'sec.retired.d': 'Signed with a node key whose certificate has lapsed.',
  'sec.permission': 'Beyond its permission',
  'sec.permission.d': 'The contractor’s genuine key used to declare a signal outage.',
  'sec.scope': 'Outside its permit',
  'sec.scope.d': 'The contractor’s genuine key used for a road it holds no permit for.',
  'sec.location': 'Unknown location',
  'sec.location.d': 'Refers to a road segment that is not on the map.',
  'sec.map': 'Different map version',
  'sec.map.d': 'Built against another map version than the receivers use.',
  'sec.expired': 'Expired',
  'sec.expired.d': 'Its validity ended before it was sent.',
  'sec.stale': 'Replayed capture',
  'sec.stale.d': 'A message recorded seven minutes ago and sent again.',
  'sec.future': 'Future timestamp',
  'sec.future.d': 'Claims to have been issued fifteen minutes from now.',
  'sec.outdated': 'Older version',
  'sec.outdated.d': 'An earlier version of the live incident arriving late.',
  'sec.conflict': 'Conflicting version',
  'sec.conflict.d': 'Same version number as the live incident with different content, as from a faulty or compromised issuer.',
  'ev.works-planned': 'Roadworks ({stage} closure) on {link} published; in place in {lead} s',
  'ev.works-active': 'Cones in place on {link}',
  'ev.works-lifted': 'Works finished on {link}: lanes reopened',
  'ev.works-rejected': 'Contractor submission rejected: {code}',
  'ev.conflict-reasserted': 'Conflicting copy heard on the air: {ref} re-issued as v{version}',
  'ev.restricted-entry': '{ref} entered a closed lane on {link}',
  'evid.title': 'Research evidence',
  'evid.lede': 'Every number on this page comes from a recorded simulation run in this repository. Where a result is small, negative or inconclusive it is shown as it is. The district, demand and capacities are synthetic.',
  'evid.legacyLang': '',
  'bm.title': 'A/B/C benchmark on the platform simulation',
  'bm.meta': '{n} seeds per variant · config {hash} · code {commit} · map {map} · generated {date}',
  'bm.statusTitle': 'Exploratory.',
  'bm.status': 'Every variant ran on the same {n} seeds with identical demand and scenario triggers, and differences are paired by seed. Synthetic district, one demand level, simulated communication. This is not a confirmatory evaluation, and it is separate from the research study below.',
  'bm.variants': 'Variants',
  'bm.v.A': 'Capable AVs with no shared city information; remote assistance first come, first served.',
  'bm.v.B': 'Validated, signed broadcast of incidents; each vehicle responds on its own; assistance first come, first served.',
  'bm.v.C': 'B plus coordination: grouped, prioritised assistance with junction-scoped authorisations, capacity-aware detour advice and signal priority for emergency vehicles.',
  'bm.v.C-nogroup': 'Ablation: C without grouped assistance (first come, first served).',
  'bm.v.C-noadvice': 'Ablation: C without detour advice.',
  'bm.v.B-priority': 'Ablation: B plus signal priority only.',
  'bm.e.blackout': '01 Signal blackout',
  'bm.e.blackout.d': 'Junctions J6, J7, J10 and J11 lose power one minute in and recover at nine minutes; {h} minutes simulated.',
  'bm.e.emergency': '02 Emergency vehicle',
  'bm.e.emergency.d': 'An ambulance leaves the hospital half a minute in for a call on South Street; {h} minutes simulated.',
  'bm.e.emergency_blackout': '01 + 02 Ambulance during the blackout',
  'bm.e.emergency_blackout.d': 'The same blackout starts at 30 s and the ambulance is dispatched at 90 s; {h} minutes simulated.',
  'bm.e.roadworks': '05 Roadworks',
  'bm.e.roadworks.d': 'Lane closure on Tower Road published at 20 s, escalated to a full closure at 200 s, lifted at 420 s; {h} minutes simulated.',
  'bm.m.systemTimeVehH': 'System time, veh·h',
  'bm.m.meanDelay': 'Delay per trip, s',
  'bm.m.meanDelayAV': 'Robotaxi delay per trip, s',
  'bm.m.meanDelayOther': 'Other vehicles, delay per trip, s',
  'bm.m.trips': 'Completed trips',
  'bm.m.exceptions': 'Assistance requests',
  'bm.m.mrcVehMin': 'Minimal risk stops, veh·min',
  'bm.m.operatorMin': 'Operator time, min',
  'bm.m.meanAssistWait': 'Wait until released, s',
  'bm.m.evDelay': 'Ambulance delay, s',
  'bm.m.evHeldByVehicles': 'Ambulance held by vehicles, s',
  'bm.m.evHeldBySignals': 'Ambulance held by signals, s',
  'bm.m.lateDiscoveries': 'Closures learned only on sight',
  'bm.m.reroutes': 'Re-routes',
  'bm.m.unauthorisedCrossings': 'Unauthorised dark crossings',
  'bm.m.boxConflicts': 'Conflicting box occupancy',
  'bm.m.restrictedEntries': 'Closed-lane entries',
  'bm.m.hardBrakes': 'Holds at the line',
  'bm.ci': 'Bar and line: mean and 95% interval. Dots: individual seeds. Lower is better for every charted metric.',
  'bm.paired': 'Paired differences',
  'bm.lower': '{v} is lower than {r} by {d} (95% interval of the difference {lo} to {hi}); lower in {k} of {n} seeds.',
  'bm.higher': '{v} is higher than {r} by {d} (95% interval of the difference {lo} to {hi}); higher in {k} of {n} seeds.',
  'bm.unclear': 'No clear difference between {v} and {r} (95% interval of the difference {lo} to {hi}); {v} lower in {k} of {n} seeds.',
  'bm.table': 'All metrics (mean ± 95% interval)',
  'bm.metric': 'Metric',
  'bm.na': 'n/a',
  'bm.invariants': 'Safety invariants over {n} runs',
  'bm.verify': 'Re-run in this browser',
  'bm.verifyNote': 'Runs one seed of an experiment for every variant in a background thread and compares every metric with the committed results. Browsers with other floating-point maths libraries may differ slightly.',
  'bm.experiment': 'Experiment',
  'bm.seed': 'Seed',
  'bm.run': 'Run',
  'bm.running': 'Running {v}…',
  'bm.match': 'identical to the committed results ({s} s)',
  'bm.mismatch': '{n} metrics differ from the committed results',
  'bm.noData': 'No benchmark results are bundled with this build. Run npm run experiments in platform/.',
  'bm.m.evArrived': 'Ambulance arrived within the horizon',
  'bm.arrivals': '{k}/{n} arrived',
  'bm.noArrival': 'did not arrive (0/{n})',
  'bm.tripsNote': 'Delay per completed trip counts only trips that finished within the horizon, so it can look better when fewer trips finish. System time, for the same demand in every variant, is the fair total.',
  'tour.start': 'Judge mode',
  'tour.startTitle': 'A guided tour of about five minutes that drives the live simulation',
  'tour.badge': 'Guided tour',
  'tour.exit': 'Exit tour',
  'tour.prev': 'Back',
  'tour.next': 'Next',
  'tour.pause': 'Pause',
  'tour.resume': 'Resume',
  'tour.restart': 'Restart tour',
  'tour.explore': 'Explore freely',
  'tour.intro.t': 'A district that runs, not an animation',
  'tour.intro.b': 'A synthetic Dubai-inspired district, built in 3D from one road network. Every vehicle is simulated in 0.1 s steps with car following, lane changes and signal plans, from a seed that makes every run repeatable.',
  'tour.traffic.t': 'Every vehicle can explain itself',
  'tour.traffic.b': 'Robotaxis, cars, vans and buses share the same physics. The inspector shows what limits the selected vehicle right now (a leader, a red signal, a junction that is not clear) and its own log of decisions.',
  'tour.blackout.t': '01 Signal blackout',
  'tour.blackout.b': 'Four signal controllers lose power and their junctions become all-way stops. At the three-lane boulevard junctions robotaxis are outside their operating domain, so they stop safely and ask for remote assistance. Under policy C, requests that share an incident and junction are handled as one group and a single junction-scoped authorisation releases them; each vehicle still applies its own checks.',
  'tour.emergency.t': '02 Emergency vehicle',
  'tour.emergency.b': 'An ambulance is dispatched. A vehicle ahead moves aside only when its own gap check passes; when it cannot, the reason is recorded instead of forcing it. Under policy C the signals ahead give the ambulance priority.',
  'tour.roadworks.t': '05 Roadworks',
  'tour.roadworks.b': 'A contractor signs a planned lane closure. The coordination node checks the contractor’s permit and timing and republishes the closure before the cones go out, so connected vehicles merge early. The closure is then extended to the whole segment and traffic is routed around it.',
  'tour.security.t': 'Messages that should not be believed',
  'tour.security.b': 'Crafted messages go on the air: altered in transit, from an unknown sender, outside a contractor’s permit, replayed from minutes ago. The node and every receiving vehicle reject each one under a specific rule. A valid signature proves who sent a message, not that it is true, and the vehicle keeps final authority.',
  'tour.evidence.t': 'The comparison, with its uncertainty',
  'tour.evidence.b': 'The same seeds, demand and triggers under policies A, B and C, plus ablations that switch off one coordination feature at a time. Every difference is shown with its 95% interval, including where coordination does not help.',
  'tour.about.t': 'What this is, and what it is not',
  'tour.about.b': 'The architecture and the services behind each scenario, what is simulated rather than measured, and the roadmap. An independent student prototype on a synthetic district, with no RTA systems, data or endorsement.',
  'tour.done.t': 'End of the tour',
  'tour.done.b': 'Everything shown can be replayed: pick a scenario on the left, switch the policy, or select any vehicle or incident.',
  'list.sep': ', ',
  'why.signal_outage': 'signal outage',
  'why.restriction': 'road restriction',
  'why.corridor': 'emergency corridor',
  'why.restriction_lifted': 'restriction lifted',
  'why.closure_seen': 'closure seen',
  'why.off_route': 'left its route',
  'why.turn': 'turn lane',
  'why.closure': 'closure ahead',
  'why.speed': 'faster lane',
  'why.clear_lane': 'clearer lane',
  'why.pull_over': 'pulling in at the kerb by its call',
  'why.v2x': 'V2X warning',
  'why.perception': 'own sensors',
  'why.remote_assistance': 'remote assistance',
  'why.signals_restored': 'signals restored',
  'why.odd_uncontrolled_junction': 'outside operating domain',
  'place.hospital': 'District hospital access (West Road)',
  'place.scene': 'Medical call, South Street east',
  'res.individual': 'Individual authorisation by an operator',
  'res.covered': 'Covered by junction authorisation {msg}',
  'res.junction': 'Junction authorisation {msg}',
  'res.left': 'Vehicle left the district',
  'res.released': 'Released',
  'res.restored': 'Signals restored before an operator was free',
  'exc.open': 'waiting',
  'exc.in_progress': 'with an operator',
  'exc.resolved': 'resolved',
  'exc.auto_resolved': 'covered by authorisation',
  'exc.withdrawn': 'withdrawn',
  'op.individual': 'individual',
  'op.group': 'group',
  'ev.kind.individual': 'an individual request',
  'ev.kind.group': 'a group of requests',
  'chk.structure': 'Structure',
  'chk.replay_duplicate': 'Replay / duplicate',
  'chk.map_version': 'Map version',
  'chk.issuer': 'Issuer',
  'chk.signature': 'Signature',
  'chk.permission': 'Permission',
  'chk.location': 'Location',
  'chk.location_and_scope': 'Location and scope',
  'chk.scope': 'Scope',
  'chk.freshness': 'Freshness',
  'chk.validity': 'Validity',
  'chk.time': 'Time',
  'chk.version': 'Version',
  'chk.origin': 'Origin',
  'incT.signal_outage': 'Signal outage at {area}',
  'incT.roadworks': 'Roadworks on {road}',
  'incT.emergency_corridor': 'Emergency corridor for {ev}',
  'incC.signal_outage': 'Controllers at {area} stopped reporting (power loss)',
  'incC.roadworks': 'Planned works by contractor {issuer} on {road} ({link})',
  'incC.emergency_corridor': 'Dispatch request from EMS-DISPATCH: {ev} from {from} to {to}',
  'eng.title': 'Engineering inspector',
  'eng.lede': 'The raw state of the running session, the recipe that reproduces it, and exports of everything the interface shows. Values are read directly from the simulation.',
  'eng.vehiclesShort': 'vehicles',
  'eng.gfx': 'graphics',
  'eng.recipe': 'Run recipe',
  'eng.recipeSub': 'The same seed, configuration and interventions reproduce this run exactly.',
  'eng.seed': 'Seed',
  'eng.policy': 'Policy and coordination features',
  'eng.density': 'Demand',
  'eng.warmup': 'Warm-up',
  'eng.odd': 'Widest approach an AV crosses at a dark junction (lanes)',
  'eng.map': 'Map version',
  'eng.operators': 'Remote assistance operators',
  'eng.detection': 'Outage detection delay',
  'eng.radio': 'Radio model',
  'eng.interventions': 'Interventions on the timeline',
  'eng.noInterventions': 'None yet: this run is the baseline.',
  'eng.exports': 'Exports',
  'eng.exportsSub': 'Built in the browser from the current state of the run.',
  'eng.exp.run': 'Run (JSON)',
  'eng.exp.trips': 'Trips (CSV)',
  'eng.exp.messages': 'Messages (CSV)',
  'eng.exp.exceptions': 'Exceptions (CSV)',
  'eng.exp.events': 'Events (CSV)',
  'eng.exp.vehicles': 'Vehicles now (CSV)',
  'eng.reasons': 'Validation reason codes',
  'eng.vehicles': 'Vehicles',
  'eng.f.stopped': 'Stopped',
  'eng.f.mrc': 'Minimal risk',
  'eng.f.connected': 'Connected',
  'eng.f.all': 'All',
  'eng.col.vehicle': 'Vehicle',
  'eng.col.segment': 'Segment',
  'eng.col.speed': 'km/h',
  'eng.col.mode': 'Mode',
  'eng.col.binding': 'Binding constraint',
  'eng.col.junction': 'Junction',
  'eng.col.phase': 'Phase',
  'eng.col.interval': 'Interval',
  'eng.col.remaining': 'Left',
  'eng.col.time': 'Time',
  'eng.col.message': 'Message',
  'eng.col.type': 'Type',
  'eng.col.issuer': 'Issuer',
  'eng.col.verdict': 'Node verdict',
  'eng.col.id': 'Id',
  'eng.col.status': 'Status',
  'eng.col.resolution': 'Resolution',
  'eng.vehiclesNote': 'Showing {n} of {total}. Select a row to inspect that vehicle in the twin.',
  'eng.openVehicle': 'Inspect {tag} in the digital twin',
  'eng.live.pause': 'Pause live updates',
  'eng.live.resume': 'Resume live updates',
  'eng.live.paused': 'Live updates paused',
  'eng.signals': 'Signals',
  'eng.dark': 'dark (all-way stop)',
  'eng.preempt': 'priority',
  'eng.closures': 'Closures on the road',
  'eng.lanes': 'lanes',
  'eng.none': 'None.',
  'eng.messages': 'Message log',
  'eng.messagesSub': '{n} messages in this run, newest first (60 shown).',
  'eng.exceptions': 'Exceptions',
  'eng.limits': 'Known limitations',
  'rc.ACCEPTED': 'Passed every check; applied as a planning constraint.',
  'rc.SCHEMA_INVALID': 'Required fields missing or of the wrong type.',
  'rc.DUPLICATE': 'Already processed; ignored, not an error.',
  'rc.MAP_VERSION_MISMATCH': 'Refers to a different map version than the receiver uses.',
  'rc.UNKNOWN_ISSUER': 'Sender is not in the trust store.',
  'rc.CERT_EXPIRED': 'The sender’s certificate is not valid at this time.',
  'rc.BAD_SIGNATURE': 'Signature does not verify with the claimed issuer’s key.',
  'rc.NOT_PERMITTED': 'The issuer may not send this message type.',
  'rc.UNKNOWN_LOCATION': 'Location not on the map, or outside the referenced road.',
  'rc.OUT_OF_SCOPE': 'Location outside the issuer’s permitted area.',
  'rc.FUTURE_TIMESTAMP': 'Issued in the future beyond the allowed clock skew.',
  'rc.NOT_YET_VALID': 'Takes effect implausibly far ahead.',
  'rc.EXPIRED': 'Its validity period has ended.',
  'rc.STALE': 'Older than the maximum age for its type, for example a replay.',
  'rc.OUTDATED_VERSION': 'Older than the version the receiver already holds.',
  'rc.CONFLICTING_UPDATE': 'Same version with different content: flagged, not applied.',
  'lim.district': 'The district, roads, demand and signal plans are synthetic and Dubai-inspired. Nothing is calibrated to real traffic counts or real streets.',
  'lim.behaviour': 'Vehicles use IDM car following and MOBIL lane changing with rule-based junction logic. There are no pedestrians, cyclists, bus stops, parking manoeuvres or driver errors.',
  'lim.works': 'Closures act on lanes along a road segment. Vehicles already in a work zone when it is set up are let through, and work zones never start inside a junction.',
  'lim.radio': 'The radio channel draws latency and loss per delivery and uses a fixed roadside-unit range. It does not model propagation, interference or channel congestion.',
  'lim.keys': 'Signing uses real ECDSA P-256 with demo keys derived from fixed labels. There is no PKI, certificate revocation or key rotation, and the trust store is fixed.',
  'lim.assist': 'Remote assistance has two operators with fixed handling times. That the fleet accepts a junction-scoped authorisation (policy C) is an assumption under test, not an operator agreement.',
  'lim.benchmark': 'The benchmark uses 10 seeds at one demand level. It is exploratory, not a confirmatory evaluation, and the ambulance delay is defined only for runs where it arrived.',
  'lim.ev': 'One emergency vehicle at a time. Signal priority is simplified to amber, all-red, then green for its approach.',
  'lim.render': 'The picture interpolates between 0.1 s simulation steps. Information overlays (pulses, zones, the corridor ribbon) are illustrative.',
  'ab.lede': 'Digital Marshal is a concept for city infrastructure that gives autonomous vehicles trustworthy, current, location-specific information during abnormal road conditions, and coordinates fleet-level exceptions when many vehicles are affected by the same event. The long-term operator could be a transport authority. This prototype simulates that architecture; it has no connection to production systems.',
  'ab.question': 'Research question',
  'ab.visual': 'The 3D city',
  'ab.visual.1': 'Buildings, the hospital, mall, landmarks, palms, street lights and benches come from the Encirra asset kit: original models generated procedurally by Team Kanban’s own Blender scripts. No third-party models, textures or HDRIs.',
  'ab.visual.2': 'Vehicles, trees, the terrain, the sea and the sky are procedural too, generated in the browser by this project’s code.',
  'ab.visual.3': 'Lighting (midday, golden hour, dusk, night) is presentation only: the simulation and every result are the same under any lighting.',
  'ab.visual.4': 'Only the district is simulated. The city around it (its streets, buildings and background traffic) is generated scenery, invented like the district itself.',
  'ab.questionText': 'Can incident-level coordination reduce fleet-wide obstruction and exception workload during shared traffic disruptions, compared with independent autonomous vehicle responses, without overriding onboard safety constraints?',
  'ab.questionNote': 'This is a hypothesis under test, not a claim of novelty. Incident messaging to connected vehicles (for example decentralised event notifications and traveller information messages) already exists; the question here is whether coordinating the fleet’s response adds measurable value.',
  'ab.scenarios': 'Scenarios',
  'ab.s1': '01 Traffic signal blackout',
  'ab.s1d': 'junction signals fail; vehicles apply their own dark-signal rules; the system shares the outage and coordinates exceptions.',
  'ab.s2': '02 Emergency vehicle priority',
  'ab.s2d': 'an ambulance crosses the district; vehicles evaluate safe yielding; infeasible yields are reported, not forced.',
  'ab.s5': '05 Temporary roadworks',
  'ab.s5d': 'lane and segment closures are published, validated and routed around, including stale and invalid updates.',
  'ab.arch': 'Logical architecture',
  'ab.archSub': 'One incident-information and coordination core shared by all three scenarios',
  'ab.d.infra': 'INFRASTRUCTURE AND ISSUERS (SIMULATED)',
  'ab.d.core': 'DIGITAL MARSHAL CORE',
  'ab.d.vehicles': 'VEHICLES (FINAL MOVEMENT AUTHORITY STAYS ON BOARD)',
  'ab.b.signals': 'Signal controllers',
  'ab.b.signals.s': 'heartbeat, phase state',
  'ab.b.works': 'Works contractors',
  'ab.b.works.s': 'signed planned closures',
  'ab.b.dispatch': 'Emergency dispatch',
  'ab.b.dispatch.s': 'corridor requests',
  'ab.b.desk': 'Remote assistance desk',
  'ab.b.desk.s': 'limited operator capacity',
  'ab.b.incident': 'Incident management',
  'ab.b.incident.s': 'stable ids, lifecycle, versions',
  'ab.b.trust': 'Trust and validation',
  'ab.b.trust.s': 'ECDSA P-256, scope, freshness',
  'ab.b.state': 'Road-state management',
  'ab.b.state.s': 'restrictions, outages, corridors',
  'ab.b.exceptions': 'Exception coordination',
  'ab.b.exceptions.s': 'grouping, WSPT priority, capacity',
  'ab.b.v2x': 'V2X message service',
  'ab.b.v2x.s': 'latency, loss, coverage (simulated)',
  'ab.b.measure': 'Experiment and measurement',
  'ab.b.measure.s': 'matched runs, metric definitions',
  'ab.b.adapter': 'Vehicle adapter',
  'ab.b.adapter.s': 'accepted message -> constraints',
  'ab.b.planner': 'AV planner and safety layer',
  'ab.b.planner.s': 'IDM, gap checks, ODD rules',
  'ab.b.twin': 'Twin renderer (this page)',
  'ab.b.twin.s': 'draws simulation state only',
  'ab.a.outage': 'outage',
  'ab.a.submit': 'submit',
  'ab.a.request': 'request',
  'ab.a.tasks': 'tasks',
  'ab.a.signed': 'signed messages',
  'ab.a.exceptions': 'exceptions',
  'ab.real': 'What is real here',
  'ab.real.1': 'A deterministic microscopic traffic simulation (car following, lane changes, signals) that drives every vehicle on screen.',
  'ab.real.2': 'Message signing and verification with audited ECDSA P-256 code; rejected messages are rejected by a specific rule.',
  'ab.real.3': 'Metrics computed from recorded runs with fixed seeds, re-runnable in the browser and exportable as CSV and JSON.',
  'ab.sim': 'What is simulated or assumed',
  'ab.sim.1': 'The district, roads, demand and signal plans are synthetic and Dubai-inspired, not real streets.',
  'ab.sim.2': 'Radio transport is modelled (latency, loss, coverage), not measured propagation.',
  'ab.sim.3': 'Remote assistance capacity, handling times and AV operational limits are stated assumptions.',
  'ab.not': 'What is not claimed',
  'ab.not.1': 'No RTA endorsement, data access or connection; independent student prototype.',
  'ab.not.2': 'No certified SAE Level 4 behaviour; the AV logic is a simulated planner in a defined domain.',
  'ab.not.3': 'No real-world validation, calibration or statistical significance beyond what the runs show.',
  'ab.roadmap': 'Roadmap',
  'ab.now': 'Now',
  'ab.next': 'Next',
  'ab.later': 'Later',
  'ab.now.1': 'Interactive twin of a synthetic district with three scenarios on one coordination core, and a guided judge mode.',
  'ab.now.2': 'Exploratory A/B/C benchmark with ablations, 95% intervals and in-browser re-runs.',
  'ab.now.3': 'Earlier corridor routing study preserved with its SUMO cross check.',
  'ab.next.1': 'A confirmatory protocol frozen before any runs: more seeds and demand levels, and a stated primary metric.',
  'ab.next.2': 'Higher-fidelity runs of the same scenarios in SUMO, replayed in the twin.',
  'ab.next.3': 'Independent human review of the coordination algorithm, the metrics and the security model.',
  'ab.later.1': 'Standards-aligned message profiles and certificate management in place of the demo keys.',
  'ab.later.2': 'Pilot design with an operator, subject to its own safety case and approvals.',
} as const;

export type I18nKey = keyof typeof en;

const ar: Record<I18nKey, string> = {
  'brand.name': 'المارشال الرقمي',
  'brand.sub': 'منصة ذكاء التنقل الذاتي',
  'brand.tagline': 'شاهد الطريق قبل أن يحدث',
  'chip.prototype': 'نموذج بحثي اصطناعي',
  'chip.prototype.title':
    'نموذج طلابي مستقل. حي اصطناعي مستوحى من دبي؛ لا أنظمة ولا بيانات ولا اعتماد من هيئة الطرق والمواصلات.',
  'view.twin': 'التوأم الرقمي',
  'view.compare': 'الأدلة',
  'view.engineering': 'الهندسة',
  'view.about': 'حول المشروع',
  'lang.toggle': 'English',
  'lang.toggle.label': 'التبديل إلى الإنجليزية',
  'status.running': 'قيد التشغيل',
  'status.paused': 'متوقف مؤقتاً',
  'status.scenario': 'السيناريو',
  'scenario.normal': 'التشغيل الاعتيادي',
  'panel.ops': 'العمليات',
  'panel.intel': 'المعلومات',
  'panel.collapse': 'طي اللوحة',
  'panel.expand.ops': 'إظهار لوحة العمليات',
  'panel.expand.intel': 'إظهار لوحة المعلومات',
  'panel.collapse.ops': 'طي لوحة العمليات',
  'panel.collapse.intel': 'طي لوحة المعلومات',
  'a11y.skip': 'تخطَّ إلى المحتوى الرئيسي',
  'a11y.twin': 'التوأم الرقمي للحي',
  'a11y.stage':
    'عرض ثلاثي الأبعاد للمدينة. اسحب للتدوير، واسحب بالزر الأيمن أو مع Shift للتحريك، ومرّر للتكبير. تدوّر مفاتيح الأسهم العرض، ويكبّر مفتاحا الزائد والناقص ويصغّران، ويعيد مفتاح Home ضبط الكاميرا.',
  'nav.views': 'طرق العرض',
  'keys.toggle': 'اختصارات المفتاح الواحد',
  'keys.note': '1–7 أوضاع الكاميرا، وW وA وS وD لتحريك الكاميرا (Q وE للدوران، وR وF للتقريب والإبعاد، واضغط Shift للإسراع)، و[ و] اللوحات، والمسافة للتشغيل أو الإيقاف المؤقت، وShift+P الأداء. أوقفها إن تعارضت مع الإدخال الصوتي أو غيره من التقنيات المساعدة.',
  'cam.overview': 'نظرة عامة',
  'cam.topdown': 'من الأعلى',
  'cam.incident': 'التركيز على الحادث',
  'cam.follow': 'تتبع مركبة',
  'cam.emergency': 'تتبع الإسعاف',
  'cam.street': 'مستوى الشارع',
  'cam.free': 'كاميرا حرة',
  'cam.wasd': 'اضغط مطولاً على W وA وS وD لتحريك الكاميرا (Q وE للدوران، وR وF للتقريب، وShift للإسراع)',
  'cam.reset': 'إعادة ضبط الكاميرا',
  'cam.toolbar': 'أوضاع الكاميرا',
  'play.play': 'تشغيل',
  'play.pause': 'إيقاف مؤقت',
  'play.restart': 'إعادة البدء',
  'play.speed': 'سرعة التشغيل',
  'play.scrub': 'الخط الزمني للمحاكاة',
  'play.next': 'الانتقال إلى الحدث المهم التالي',
  'play.time': 'زمن المحاكاة',
  'play.ahead': 'جارٍ محاكاة الفترة القادمة',
  'gfx.title': 'الرسوميات',
  'gfx.auto': 'تلقائي',
  'gfx.high': 'عالية',
  'gfx.balanced': 'متوازنة',
  'gfx.performance': 'أداء',
  'gfx.perf': 'مراقب الأداء',
  'gfx.downgraded': 'تم خفض الرسوميات إلى {q} للحفاظ على سلاسة المحاكاة.',
  'perf.fps': 'إطار/ث',
  'perf.close': 'إغلاق لوحة الأداء',
  'perf.frame': 'زمن الإطار',
  'perf.calls': 'استدعاءات الرسم',
  'perf.tris': 'المثلثات',
  'perf.geo': 'الأشكال',
  'perf.tex': 'الخامات',
  'perf.sim': 'خطوة المحاكاة',
  'perf.quality': 'الجودة',
  'perf.pr': 'نسبة البكسل',
  'nowebgl.title': 'تقنية WebGL غير متاحة',
  'nowebgl.body':
    'لا يستطيع هذا المتصفح أو الجهاز إنشاء سياق WebGL، لذلك لا يمكن رسم المدينة ثلاثية الأبعاد. تستمر المحاكاة في العمل، وتعرض هذه الخريطة ثنائية الأبعاد الحالة الحية نفسها.',
  'nowebgl.map': 'خريطة ثنائية الأبعاد للحي: الطرق والتقاطعات (المطفأة بالأحمر) والإغلاقات وكل مركبة',
  'loading': 'جارٍ تجهيز الحي',
  'display.title': 'العرض',
  'display.labels': 'تسميات التقاطعات',
  'display.v2x': 'طبقات تدفق المعلومات',
  'display.routes': 'مسارات المركبات',
  'intel.network': 'الشبكة',
  'intel.pending': 'تُربط محاكاة المرور في المرحلة التالية. الكاميرا ومستويات الرسوميات والعروض تعمل الآن.',
  'caption.district': 'حي حضري اصطناعي مستوحى من دبي',
  'caption.district.sub': 'تخطيط مُتخيَّل · أسماء الطرق رموز · ليست شوارع حقيقية',
  'lbl.ev.free': 'الممر خالٍ',
  'lbl.ev.leader': 'مركبة أمامها',
  'lbl.ev.signal': 'إشارة أمامها',
  'lbl.ev.junction': 'تعبر تقاطعًا',
  'lbl.ev.arrive': 'تقترب من الوجهة',
  'lbl.ev.arrived': 'في موقع البلاغ',
  'lbl.ev.speed': '{n} كم/س',
  'lbl.dark': 'الإشارة متوقفة',
  'lbl.works.lane': 'مسار مغلق',
  'lbl.works.full': 'الطريق مغلق',
  'lbl.works.planned': 'تم نشر الإغلاق',
  'tod.title': 'الإضاءة',
  'tod.day': 'منتصف النهار',
  'tod.golden': 'الساعة الذهبية',
  'tod.dusk': 'الغسق',
  'tod.night': 'الليل',
  'tod.note': 'الإضاءة فقط: لا تتغير المحاكاة ولا نتائجها.',
  'map.title': 'خريطة الحي',
  'map.zoomIn': 'تكبير الخريطة',
  'map.zoomOut': 'تصغير الخريطة',
  'map.locate': 'توسيط الخريطة على الكاميرا',
  'map.hint': 'انقر على الخريطة لنقل الكاميرا إلى هناك',
  'load.kit': 'تحميل الحي ثلاثي الأبعاد',
  'load.build': 'بناء الحي',
  'load.note': 'حي اصطناعي مستوحى من دبي · نموذج بحثي طلابي مستقل · ليس نظامًا تابعًا لهيئة الطرق والمواصلات',
  'sim.title': 'المحاكاة',
  'sim.density': 'الطلب المروري',
  'sim.densityValue': '{pct}% من الطلب المسائي المرجعي',
  'sim.seed': 'البذرة',
  'sim.densityNote': 'يُطبق من الآن ويُسجَّل، فتعيده الإعادات كما هو.',
  'intel.active': 'المركبات في الحي',
  'intel.moving': 'متحركة',
  'intel.stopped': 'متوقفة',
  'intel.atSignals': 'عند الإشارات',
  'intel.speed': 'متوسط السرعة',
  'intel.trips': 'رحلات مكتملة',
  'intel.delay': 'متوسط التأخير لكل رحلة',
  'intel.mix': 'تركيبة الأسطول',
  'intel.stoppedSeries': 'المركبات المتوقفة، آخر 6 دقائق',
  'intel.hint': 'انقر على أي مركبة في المدينة لمعرفة ما تفعله ولماذا.',
  'intel.nearMiss': 'توقفات طارئة عند دخول التقاطع',
  'intel.queued': 'بانتظار الدخول عند الأطراف',
  'cls.robotaxi': 'سيارة أجرة ذاتية (محاكاة)',
  'cls.car': 'سيارة خاصة',
  'cls.van': 'شاحنة توصيل',
  'cls.bus': 'حافلة',
  'cls.ambulance': 'سيارة إسعاف',
  'veh.identity': 'الهوية',
  'veh.motion': 'الحركة',
  'veh.route': 'المسار',
  'veh.planning': 'التخطيط: لماذا تفعل ذلك',
  'veh.timeline': 'سجل القرارات',
  'veh.autonomy': 'نمط القيادة',
  'veh.autonomy.av': 'مخطط ذاتي محاكى (نموذج بحثي، غير معتمد)',
  'veh.autonomy.human': 'نموذج سائق بشري',
  'veh.connected': 'متصلة V2X',
  'veh.notConnected': 'غير متصلة',
  'veh.speed': 'السرعة',
  'veh.accel': 'التسارع',
  'veh.road': 'الطريق',
  'veh.lane': 'المسرب',
  'veh.laneOf': '{lane} من {lanes}',
  'veh.from': 'من',
  'veh.to': 'إلى',
  'veh.remaining': 'المتبقي',
  'veh.inDistrict': 'الوقت داخل الحي',
  'veh.stoppedFor': 'وقت التوقف',
  'veh.reroutes': 'إعادات التوجيه',
  'veh.laneChanges': 'تغييرات المسرب',
  'veh.follow': 'تتبع',
  'veh.close': 'إغلاق المفتش',
  'veh.exited': 'غادرت هذه المركبة الحي. تُعرض آخر حالة معروفة.',
  'veh.mode.drive': 'تسير',
  'veh.mode.mrc': 'حالة الحد الأدنى من المخاطر',
  'veh.mode.arrived': 'وصلت',
  'bind.free': 'تسير بالسرعة المرغوبة؛ لا شيء أمامها يقيدها.',
  'bind.leader': 'تتبع {ref} على بعد {gap} م.',
  'bind.signal.stop': 'متوقفة عند إشارة حمراء في {ref}. تصبح خضراء لحركتها بعد {extra} ث.',
  'bind.signal.slow': 'تخفف السرعة لإشارة حمراء في {ref}، على بعد {gap} م من خط التوقف.',
  'bind.awsc.self': 'إشارات {ref} مطفأة. تتعامل مع التقاطع كتوقف إلزامي من جميع الاتجاهات ويجب أن تتوقف عند الخط أولاً.',
  'bind.awsc.other': 'توقف من جميع الاتجاهات: تنتظر {ref} التي توقفت أولاً ومسارها متعارض.',
  'bind.box': 'منطقة التقاطع تشغلها {ref} على مسار متعارض؛ تنتظر خلوها.',
  'bind.exit': 'مسرب الخروج ممتلئ بعد التقاطع ({ref})؛ لا تدخل كي تبقى المنطقة خالية.',
  'bind.curve': 'تخفف إلى سرعة انعطاف آمنة عند التقاطع {ref}.',
  'bind.closure': 'إغلاق فعلي أمامها ({ref})؛ تتوقف أو تندمج حوله.',
  'bind.mrc': 'توقفت بأمان قبل {ref}: تقاطع غير منظم بهذا العرض خارج نطاق تشغيل المركبة. تنتظر المساعدة عن بعد ولا تعبر من تلقاء نفسها.',
  'bind.yield': 'تفسح الطريق لمركبة طوارئ.',
  'bind.lanechange': 'تنتظر فجوة آمنة للوصول إلى المسرب المطلوب.',
  'bind.arrive': 'تصل إلى وجهتها.',
  'veh.onScene': 'في موقع البلاغ: متوقفة بمحاذاة الرصيف والأضواء التحذيرية تعمل.',
  'bind.spawn': 'تنتظر الدخول إلى الحي.',
  'log.SPAWN': 'دخلت الحي من {from}',
  'log.ROUTE': 'خططت مساراً من {links} مقاطع (زمن حر {ff} ث)',
  'log.REROUTE': 'أعادت التوجيه ({reason}) عبر {via}',
  'log.STOP_SIGNAL': 'تتوقف للإشارة الحمراء في {junction}',
  'log.GO_SIGNAL': 'أخضر في {junction}: تتابع',
  'log.AMBER_COMMIT': 'أصفر في {junction} لكنها قريبة جداً للتوقف: التزمت بالعبور',
  'log.AWSC_STOP': 'توقفت عند التقاطع المطفأ {junction} (توقف من جميع الاتجاهات)',
  'log.AWSC_GO': 'دورها في {junction}: تعبر',
  'log.LANE_CHANGE': 'غيرت المسرب {from} \u2190 {to} ({reason})',
  'log.MISSED_TURN': 'لا فجوة آمنة للوصول لمسرب الانعطاف؛ سلكت مخرجاً آخر وأعادت التخطيط',
  'log.BOX_WAIT': 'انتظرت خلو منطقة التقاطع',
  'log.EXIT_WAIT': 'انتظرت: مسرب الخروج ممتلئ',
  'log.MRC': 'توقف بأدنى مخاطر عند {junction} (خارج نطاق التشغيل، مدخل من {lanes} مسارب)',
  'log.ASSIST_REQUEST': 'طلبت مساعدة عن بعد',
  'log.ASSIST_GRANTED': 'أُفرج عنها من توقف أدنى المخاطر ({by})',
  'log.YIELD': 'انتقلت إلى المسرب {to} لتمر {ev} ({via})',
  'log.YIELD_INFEASIBLE': 'تعذر إفساح الطريق لـ {ev} بأمان: {reason}',
  'log.MSG_RX': 'استلمت الرسالة {msg}',
  'log.MSG_REJECT': 'رفضت الرسالة {msg}: {reason}',
  'log.CLOSURE_SEEN': 'رأت الإغلاق عند {where}',
  'log.ARRIVED': 'وصلت إلى {place}',
  'log.EXITED': 'غادرت الحي عند {at}',
  'log.NO_ALTERNATIVE': 'لا مسار بديل ممكن ({reason})؛ تحتفظ بخطتها',
  'log.ADVICE': 'اعتمدت نصيحة التحويل المنسقة عبر {via}',

  'scn.title': 'السيناريو',
  'scn.normal': 'التشغيل الاعتيادي',
  'scn.normal.d': 'حركة مسائية وجميع الإشارات تعمل. الخط الأساسي الذي يبدأ منه كل سيناريو.',
  'scn.blackout': '01 انقطاع الإشارات',
  'scn.blackout.d': 'تفقد وحدات التحكم بالإشارات الطاقة. تطبق المركبات الذاتية قواعدها الخاصة؛ وتشارك المدينة الانقطاع وتنسق الاستثناءات.',
  'scn.emergency': '02 مركبة طوارئ',
  'scn.emergency.d': 'سيارة إسعاف تعبر الحي. تقيّم المركبات إمكانية إفساح الطريق بأمان؛ ويُبلّغ عن الحالات المتعذرة دون فرضها.',
  'scn.roadworks': '05 أعمال طرق',
  'scn.roadworks.d': 'تُنشر إغلاقات المسارب والمقاطع وتُتحقق صحتها ويُلتف حولها، بما في ذلك التحديثات القديمة وغير الصالحة.',
  'bo.junctions': 'التقاطعات التي تفقد الطاقة',
  'bo.restoreAfter': 'تعود الطاقة بعد',
  'bo.manual': 'يدوي',
  'bo.minutes': '{n} دقيقة',
  'bo.trigger': 'تشغيل الانقطاع',
  'bo.restore': 'إعادة الطاقة الآن',
  'bo.note': 'تتعامل المركبات الذاتية مع الإشارات المطفأة كتوقف من جميع الاتجاهات. المداخل الأعرض من {lanes} مسارب خارج نطاق التشغيل المحاكى: تتوقف المركبة بأمان وتطلب مساعدة عن بعد من أسطولها.',
  'bo.active': 'مطفأة الآن: {list}',
  'bo.wide': 'مداخل من {n} مسارات',
  'bo.darkState': 'بلا طاقة',
  'bo.legend': 'الكهرماني: محدد. الأحمر: بلا طاقة. النقطة: مداخل يزيد عدد مساراتها على {lanes}.',
  'pol.title': 'سياسة التنسيق',
  'pol.A': 'A  بلا معلومات مدينة مشتركة',
  'pol.A.d': 'ترى المركبات الانقطاع بحساساتها فقط. تُعالج طلبات المساعدة عن بعد بترتيب الوصول.',
  'pol.B': 'B  بث موثّق للحوادث',
  'pol.B.d': 'ينشر المارشال الرقمي رسائل حوادث موقعة؛ تتحقق كل مركبة منها وتستجيب بمفردها. الطلبات بترتيب الوصول.',
  'pol.C': 'C  بث + تنسيق الأسطول',
  'pol.C.d': 'B مع التنسيق: تُجمع الطلبات المشتركة في الحادث والتقاطع وتُرتب أولوياتها؛ ويغطي تفويض واحد على مستوى التقاطع المجموعة؛ وتُوزع التحويلات حسب السعة؛ وتحصل سيارة الإسعاف المقتربة على أولوية الإشارات.',
  'pol.assumption': 'الافتراض قيد الاختبار (C): يقبل مشغل الأسطول تفويضاً على مستوى التقاطع طوال الحادث. وتظل كل مركبة تطبق فحوص التوقف والفجوات الخاصة بها.',
  'pol.replay': 'التبديل يعيد تشغيل هذه الجولة من البداية بالبذرة والمحفزات نفسها.',
  'comms.title': 'الاتصالات (حقن الأعطال)',
  'comms.loss': 'فقد حزم إضافي',
  'comms.latency': 'تأخير إضافي',
  'comms.battery': 'بطارية احتياطية للوحدات الطرفية',
  'comms.cell': 'الشبكة الخلوية متاحة',
  'comms.lossValue': '{n}٪',
  'comms.latencyValue': '{n} ملّي ثانية',
  'scn.reset': 'إعادة ضبط السيناريو',
  'scn.resetNote': 'يمسح جميع المحفزات ويعيد تشغيل الجولة.',
  'eng.toggle': 'المعاملات الهندسية',
  'dm.title': 'المارشال الرقمي',
  'dm.policy': 'السياسة',
  'dm.incidents': 'الحوادث',
  'dm.none': 'لا حوادث. الحي يعمل بشكل اعتيادي.',
  'dm.exceptions': 'المساعدة عن بعد',
  'dm.open': 'بانتظار',
  'dm.inProgress': 'لدى مشغل',
  'dm.resolved': 'محلولة',
  'dm.auto': 'مشمولة بتفويض',
  'dm.withdrawn': 'مسحوبة',
  'dm.operators': 'المشغلون',
  'dm.idle': 'متاح',
  'dm.messages': 'رسائل V2X',
  'dm.published': 'منشورة',
  'dm.delivered': 'مُسلّمة',
  'dm.rejectedN': 'مرفوضة',
  'dm.latency': 'متوسط التأخير',
  'dm.mrcNow': 'مركبات ذاتية في توقف أدنى المخاطر',
  'dm.mrcTime': 'زمن توقف أدنى المخاطر',
  'inc.title': 'الحادث',
  'inc.type.signal_outage': 'انقطاع الإشارات',
  'inc.type.emergency_corridor': 'ممر طوارئ',
  'inc.type.roadworks': 'أعمال طرق',
  'inc.status.active': 'نشط',
  'inc.status.resolved': 'محلول',
  'inc.status.detected': 'مُكتشف',
  'inc.area': 'المنطقة المتأثرة',
  'inc.issuer': 'المُصدِر',
  'inc.version': 'الإصدار',
  'inc.created': 'فُتح',
  'inc.resolvedAt': 'حُل',
  'inc.cause': 'الحقيقة الميدانية',
  'inc.reach': 'المركبات التي وصلتها',
  'inc.reachText': '{received} استلمت، {accepted} قبلت، {rejected} رفضت',
  'inc.queues': 'متوقفة على المداخل',
  'inc.mrc': 'في توقف أدنى المخاطر',
  'inc.lifecycle': 'دورة حياة الرسائل',
  'inc.exceptions': 'الاستثناءات في هذا الحادث',
  'inc.noExceptions': 'لم يُرفع أي استثناء.',
  'inc.close': 'إغلاق مفتش الحادث',
  'inc.focus': 'توجيه الكاميرا إلى هذا الحادث',
  'inc.notPublished': 'السياسة A: اكتشفته عقدة التنسيق لكن لم يُشارك مع المركبات.',
  'msg.checks': 'فحوص التحقق',
  'msg.injected': 'محقونة',
  'msg.published': 'منشورة',
  'msg.v.ok': 'مقبولة',
  'msg.v.warn': 'مُعلَّمة للمراجعة',
  'msg.v.bad': 'مرفوضة',
  'vdm.title': 'الحادث والرسائل',
  'vdm.none': 'لم تُستلم رسائل حوادث.',
  'vdm.avoid': 'يجب تجنبها (خارج نطاقها): {list}',
  'vdm.auth': 'مفوضة بعبور {junction} ({scope})',
  'vdm.exceptions': 'طلبات المساعدة عن بعد',
  'vdm.notConnected': 'غير متصلة: هذه المركبة تعرف فقط ما تراه حساساتها.',
  'feed.title': 'الأحداث المباشرة',
  'ev.power-loss': 'انقطعت الطاقة في {junctions}: الإشارات مطفأة',
  'ev.outage-detected': 'اكتُشف الانقطاع ({delay} ث): الحادث {ref}',
  'ev.msg-published': 'نُشرت {type} إصدار {version} للحادث {incident}',
  'ev.assist-request': 'توقفت {ref} عند {junction} وطلبت المساعدة',
  'ev.assist-task': 'تولى المشغل {operator} {kind} عند {junction} ({n})',
  'ev.assist-granted': 'أفرج مشغل عن مركبة عند {junction}',
  'ev.junction-authorized': '{ref}: فوّض الأسطول التوقف من جميع الاتجاهات لـ {n} مركبة',
  'ev.power-restored': 'عادت الطاقة في {junctions}',
  'ev.incident-resolved': 'حُل الحادث {ref}',
  'ev.advisory-batch': 'أُرسل توزيع التحويلات إلى {n} مركبة',
  'ev.inject-rejected': 'رُفضت رسالة محقونة: {code}',
  'ev.inject-accepted': 'قُبلت رسالة محقونة ({code})',
  'ev.hard-brake': 'توقف طارئ من {ref} عند {junction}',
  'ev.box-violation': 'مخالفة منطقة التقاطع من {ref}',

  'ev.dispatch': 'إرسال سيارة إسعاف',
  'ev.from': 'من',
  'ev.to': 'إلى',
  'ev.notePolicy': 'لا تفسح أي مركبة الطريق إلا إذا اجتاز فحص الفجوة الخاص بها. تضيف السياسة B إنذاراً مبكراً برسائل ممر موقعة؛ وتطلب السياسة C أيضاً أولوية الإشارات على المسار.',
  'ev.active': '{tag} في الطريق',
  'ev.mission': 'مهمة الطوارئ',
  'ev.dispatchedAt': 'وقت الإرسال',
  'ev.elapsed': 'المنقضي',
  'ev.travel': 'زمن الرحلة',
  'ev.ffT': 'الزمن الحر على هذا المسار',
  'ev.delay': 'التأخير',
  'ev.obstructed': 'دون 80% من سرعتها',
  'ev.obs.vehicle': 'بسبب مركبات أمامها',
  'ev.obs.signal': 'بسبب الإشارات',
  'ev.obs.junction': 'بسبب تقاطع مزدحم',
  'ev.obs.other': 'أخرى',
  'ev.yields': 'قرارات إفساح الطريق',
  'ev.yieldsText': '{ok} إفساح آمن، {no} متعذر',
  'ev.preempts': 'منح أولوية الإشارات',
  'ev.arrived': 'وصلت',
  'ev.route': 'الممر',
  'ev.follow': 'تتبع سيارة الإسعاف',
  'yield.single_lane_no_shoulder': 'مسرب واحد بلا كتف، فلا مكان آمن للتحرك',
  'yield.held_at_red_signal': 'متوقفة عند إشارة حمراء؛ لن تدخل التقاطع والإشارة حمراء',
  'yield.adjacent_lane_occupied': 'المسرب المجاور مشغول ({by}، فجوة {gap} م): لا فجوة آمنة',
  'yield.stopped_minimal_risk': 'متوقفة في حالة الحد الأدنى من المخاطر',
  'log.YIELD.v': 'انتقلت إلى المسرب {to} لتمر {ev} ({via})',
  'ev.ev-dispatched': 'أُرسلت سيارة الإسعاف {ref} إلى {to}',
  'ev.ev-preempt': 'أولوية الإشارة في {ref} لـ {ev}',
  'ev.ev-arrived': 'وصلت {ref} بعد {travel} ث (الزمن الحر {ff} ث)',
  'msg.submitted': 'مُقدّمة إلى العقدة',
  'hdr.undetected': 'انقطاع إشارات (لم يُكتشف بعد)',
  'rw.contractor': 'المقاول',
  'rw.where': 'الموقع',
  'rw.permit': 'نطاق التصريح',
  'rw.planLane': 'تخطيط إغلاق مسرب',
  'rw.escalate': 'التصعيد إلى إغلاق كامل',
  'rw.lift': 'انتهاء الأعمال',
  'rw.stage.lane': 'مسرب',
  'rw.stage.full': 'كامل',
  'rw.what.lane': 'إغلاق مسرب',
  'rw.what.full': 'إغلاق كامل',
  'rw.pending': 'نُشر {what}؛ تُوضع الأقماع خلال {n} ث',
  'rw.inPlace.lane': 'المسرب {lanes} مغلق من {s0} م إلى {s1} م',
  'rw.inPlace.full': '{road} مغلق أمام جميع المركبات',
  'rw.lifted': 'انتهت الأعمال: جميع المسارب مفتوحة',
  'rw.rejected': 'رفضت العقدة طلب المقاول ({code})؛ لم يُنشر شيء',
  'rw.submission': 'طلب المقاول',
  'rw.subText': '{code} · {n} فحوص',
  'rw.audit': 'تدقيق السلامة',
  'rw.late': 'علمت بالإغلاق عند رؤيته فقط',
  'rw.restricted': 'دخول إلى مسرب مغلق',
  'rw.note': 'يوقّع المقاول خطته؛ وتتحقق العقدة من المُصدِر والصلاحية ونطاق التصريح والتوقيت، ثم تعيد نشرها مسبقاً. تندمج المركبات المتصلة مبكراً وتلتف حول المقطع المغلق، وتبقى كل مركبة تتفاعل مع الأقماع التي تراها.',
  'sec.title': 'اختبارات أمن الرسائل',
  'sec.intro': 'يبث كل اختبار رسالة مصطنعة واحدة. تتحقق منها العقدة وكل مركبة تستقبلها بشكل مستقل، ويعرض السطر ما قررته فعلاً.',
  'sec.policyA': 'لا توجد في السياسة A قناة رسائل مشتركة، فلا شيء يمكن الحقن فيه. انتقل إلى B أو C.',
  'sec.needsIncident': 'يتطلب حادثاً نشطاً أولاً (مثلاً خطط لإغلاق المسرب).',
  'sec.inject': 'حقن',
  'sec.injectNamed': 'حقن: {name}',
  'sec.passed': 'نجح الاختبار',
  'sec.failed': 'فشل الاختبار',
  'sec.expect': 'المتوقع',
  'sec.node': 'العقدة',
  'sec.vehicles': 'المركبات: {rejected} رفضت، {flagged} أشّرت، {accepted} قبلت',
  'sec.inflight': 'قيد التوصيل إلى المركبات…',
  'sec.none': 'لم تستقبلها أي مركبة في النطاق.',
  'sec.note': 'تستخدم الاختبارات مفاتيح تجريبية للمُصدِرين المحاكَين. يثبت التوقيع الصحيح هوية المرسل وعدم تعديل الرسالة، لا صحة محتواها. وتبقى سلطة الحركة النهائية لكل مركبة.',
  'sec.tampered': 'رسالة معدّلة',
  'sec.tampered.d': 'رسالة حقيقية عُدّلت أثناء النقل، هنا لنقل الإغلاق إلى المسرب المفتوح.',
  'sec.forged': 'رسالة مزورة باسم العقدة',
  'sec.forged.d': 'تدّعي أنها من عقدة التنسيق لكنها موقعة بمفتاح آخر.',
  'sec.rogue': 'مرسل غير معروف',
  'sec.rogue.d': 'جهاز خارج مخزن الثقة يعلن إغلاق الشارع الرئيسي.',
  'sec.retired': 'مفتاح متقاعد',
  'sec.retired.d': 'موقعة بمفتاح عقدة انتهت صلاحية شهادته.',
  'sec.permission': 'خارج صلاحياته',
  'sec.permission.d': 'مفتاح المقاول الحقيقي يُستخدم لإعلان انقطاع إشارات.',
  'sec.scope': 'خارج تصريحه',
  'sec.scope.d': 'مفتاح المقاول الحقيقي يُستخدم لطريق لا يملك تصريحاً له.',
  'sec.location': 'موقع غير معروف',
  'sec.location.d': 'تشير إلى مقطع طريق غير موجود على الخريطة.',
  'sec.map': 'إصدار خريطة مختلف',
  'sec.map.d': 'مبنية على إصدار خريطة غير الذي يستخدمه المستقبِلون.',
  'sec.expired': 'منتهية الصلاحية',
  'sec.expired.d': 'انتهت صلاحيتها قبل إرسالها.',
  'sec.stale': 'إعادة بث رسالة ملتقطة',
  'sec.stale.d': 'رسالة سُجلت قبل سبع دقائق وأُعيد إرسالها.',
  'sec.future': 'طابع زمني مستقبلي',
  'sec.future.d': 'تدّعي أنها صدرت بعد خمس عشرة دقيقة من الآن.',
  'sec.outdated': 'إصدار أقدم',
  'sec.outdated.d': 'إصدار سابق من الحادث النشط يصل متأخراً.',
  'sec.conflict': 'إصدار متعارض',
  'sec.conflict.d': 'رقم الإصدار نفسه للحادث النشط بمحتوى مختلف، كما لو صدرت عن مُصدِر معطّل أو مخترق.',
  'ev.works-planned': 'نُشرت أعمال طرق (إغلاق {stage}) على {link}؛ تُنفذ خلال {lead} ث',
  'ev.works-active': 'وُضعت الأقماع على {link}',
  'ev.works-lifted': 'انتهت الأعمال على {link}: أُعيد فتح المسارب',
  'ev.works-rejected': 'رُفض طلب المقاول: {code}',
  'ev.conflict-reasserted': 'رُصدت نسخة متعارضة على الهواء: أُعيد إصدار {ref} بالإصدار {version}',
  'ev.restricted-entry': 'دخلت {ref} مسرباً مغلقاً على {link}',
  'evid.title': 'الأدلة البحثية',
  'evid.lede': 'كل رقم في هذه الصفحة مأخوذ من تشغيل محاكاة مسجل في هذا المستودع. وتُعرض النتائج الصغيرة أو السلبية أو غير الحاسمة كما هي. الحي والطلب والسعات اصطناعية.',
  'evid.legacyLang': 'يُعرض القسم التالي بلغته الأصلية دون تعديل.',
  'bm.title': 'مقارنة السياسات A/B/C على محاكاة المنصة',
  'bm.meta': '{n} بذور لكل متغير · الإعداد {hash} · الشيفرة {commit} · الخريطة {map} · أُنشئت {date}',
  'bm.statusTitle': 'استكشافية.',
  'bm.status': 'شُغّل كل متغير على البذور نفسها ({n}) بطلب ومحفزات سيناريو متطابقة، وتُقارن الفروق زوجياً لكل بذرة. حي اصطناعي، ومستوى طلب واحد، واتصالات محاكاة. هذه ليست تقييماً تأكيدياً، وهي منفصلة عن الدراسة البحثية أدناه.',
  'bm.variants': 'المتغيرات',
  'bm.v.A': 'مركبات ذاتية قادرة دون معلومات مشتركة من المدينة؛ المساعدة عن بعد بترتيب الوصول.',
  'bm.v.B': 'بث موقّع ومُتحقق منه للحوادث؛ تستجيب كل مركبة بمفردها؛ المساعدة بترتيب الوصول.',
  'bm.v.C': 'B مع التنسيق: مساعدة مجمّعة ومرتبة حسب الأولوية مع تفويضات على مستوى التقاطع، ونصائح تحويل تراعي السعة، وأولوية الإشارات لمركبات الطوارئ.',
  'bm.v.C-nogroup': 'استبعاد: C دون تجميع المساعدة (بترتيب الوصول).',
  'bm.v.C-noadvice': 'استبعاد: C دون نصائح التحويل.',
  'bm.v.B-priority': 'استبعاد: B مع أولوية الإشارات فقط.',
  'bm.e.blackout': '01 انقطاع الإشارات',
  'bm.e.blackout.d': 'تفقد التقاطعات J6 وJ7 وJ10 وJ11 الطاقة بعد دقيقة وتعود عند الدقيقة التاسعة؛ محاكاة {h} دقيقة.',
  'bm.e.emergency': '02 مركبة طوارئ',
  'bm.e.emergency.d': 'تغادر سيارة إسعاف المستشفى بعد نصف دقيقة لبلاغ في الشارع الجنوبي؛ محاكاة {h} دقيقة.',
  'bm.e.emergency_blackout': '01 + 02 إسعاف أثناء الانقطاع',
  'bm.e.emergency_blackout.d': 'يبدأ الانقطاع نفسه عند 30 ث وتُرسل سيارة الإسعاف عند 90 ث؛ محاكاة {h} دقيقة.',
  'bm.e.roadworks': '05 أعمال طرق',
  'bm.e.roadworks.d': 'إغلاق مسرب على طريق البرج يُنشر عند 20 ث، ويُصعّد إلى إغلاق كامل عند 200 ث، ويُرفع عند 420 ث؛ محاكاة {h} دقيقة.',
  'bm.m.systemTimeVehH': 'زمن النظام، مركبة·ساعة',
  'bm.m.meanDelay': 'التأخير لكل رحلة، ث',
  'bm.m.meanDelayAV': 'تأخير سيارات الأجرة الذاتية لكل رحلة، ث',
  'bm.m.meanDelayOther': 'المركبات الأخرى، التأخير لكل رحلة، ث',
  'bm.m.trips': 'الرحلات المكتملة',
  'bm.m.exceptions': 'طلبات المساعدة',
  'bm.m.mrcVehMin': 'توقفات أدنى المخاطر، مركبة·دقيقة',
  'bm.m.operatorMin': 'وقت المشغلين، دقيقة',
  'bm.m.meanAssistWait': 'الانتظار حتى الإفراج، ث',
  'bm.m.evDelay': 'تأخير الإسعاف، ث',
  'bm.m.evHeldByVehicles': 'إعاقة الإسعاف بالمركبات، ث',
  'bm.m.evHeldBySignals': 'إعاقة الإسعاف بالإشارات، ث',
  'bm.m.lateDiscoveries': 'إغلاقات عُلم بها عند رؤيتها فقط',
  'bm.m.reroutes': 'إعادات التوجيه',
  'bm.m.unauthorisedCrossings': 'عبور غير مصرح لتقاطعات مطفأة',
  'bm.m.boxConflicts': 'إشغال متعارض لمنطقة التقاطع',
  'bm.m.restrictedEntries': 'دخول إلى مسارب مغلقة',
  'bm.m.hardBrakes': 'توقفات عند الخط',
  'bm.ci': 'الشريط والخط: المتوسط ومجال الثقة 95%. النقاط: البذور منفردة. الأقل أفضل في كل المقاييس المرسومة.',
  'bm.paired': 'الفروق الزوجية',
  'bm.lower': '{v} أقل من {r} بمقدار {d} (مجال 95% للفرق من {lo} إلى {hi})؛ أقل في {k} من {n} بذور.',
  'bm.higher': '{v} أعلى من {r} بمقدار {d} (مجال 95% للفرق من {lo} إلى {hi})؛ أعلى في {k} من {n} بذور.',
  'bm.unclear': 'لا فرق واضح بين {v} و{r} (مجال 95% للفرق من {lo} إلى {hi})؛ {v} أقل في {k} من {n} بذور.',
  'bm.table': 'جميع المقاييس (المتوسط ± مجال 95%)',
  'bm.metric': 'المقياس',
  'bm.na': 'غير متاح',
  'bm.invariants': 'ثوابت السلامة في {n} تشغيلاً',
  'bm.verify': 'إعادة التشغيل في هذا المتصفح',
  'bm.verifyNote': 'يشغّل بذرة واحدة من تجربة لكل متغير في خيط خلفي ويقارن كل مقياس بالنتائج المحفوظة. قد تختلف النتائج قليلاً في متصفحات تستخدم مكتبات رياضيات عشرية أخرى.',
  'bm.experiment': 'التجربة',
  'bm.seed': 'البذرة',
  'bm.run': 'تشغيل',
  'bm.running': 'جارٍ تشغيل {v}…',
  'bm.match': 'مطابق للنتائج المحفوظة ({s} ث)',
  'bm.mismatch': '{n} مقاييس تختلف عن النتائج المحفوظة',
  'bm.noData': 'لا توجد نتائج مقارنة مضمنة في هذا الإصدار. شغّل npm run experiments في platform/.',
  'bm.m.evArrived': 'وصل الإسعاف ضمن المدة',
  'bm.arrivals': 'وصل في {k}/{n}',
  'bm.noArrival': 'لم يصل (0/{n})',
  'bm.tripsNote': 'يحسب التأخير لكل رحلة مكتملة الرحلات التي انتهت ضمن المدة فقط، لذا قد يبدو أفضل عندما تكتمل رحلات أقل. أما زمن النظام، للطلب نفسه في كل متغير، فهو المجموع المنصف.',
  'tour.start': 'وضع التحكيم',
  'tour.startTitle': 'جولة إرشادية لنحو خمس دقائق تقود المحاكاة الحية',
  'tour.badge': 'جولة إرشادية',
  'tour.exit': 'إنهاء الجولة',
  'tour.prev': 'السابق',
  'tour.next': 'التالي',
  'tour.pause': 'إيقاف مؤقت',
  'tour.resume': 'متابعة',
  'tour.restart': 'إعادة الجولة',
  'tour.explore': 'الاستكشاف بحرية',
  'tour.intro.t': 'حي يعمل فعلاً، لا رسوم متحركة',
  'tour.intro.b': 'حي اصطناعي مستوحى من دبي، مبني ثلاثي الأبعاد من شبكة طرق واحدة. تُحاكى كل مركبة بخطوات من 0.1 ث مع تتبع المركبات وتغيير المسارب وخطط الإشارات، انطلاقاً من بذرة تجعل كل تشغيل قابلاً للتكرار.',
  'tour.traffic.t': 'كل مركبة تشرح نفسها',
  'tour.traffic.b': 'تتشارك سيارات الأجرة الذاتية والسيارات والشاحنات الصغيرة والحافلات الفيزياء نفسها. يعرض المفتش ما يقيّد المركبة المختارة الآن (مركبة أمامها أو إشارة حمراء أو تقاطع غير خالٍ) وسجل قراراتها.',
  'tour.blackout.t': '01 انقطاع الإشارات',
  'tour.blackout.b': 'تفقد أربع وحدات تحكم بالإشارات الطاقة فتصبح تقاطعاتها توقفاً إلزامياً من جميع الاتجاهات. عند تقاطعات الشارع الرئيسي ذات المسارب الثلاثة تكون سيارات الأجرة الذاتية خارج نطاق تشغيلها، فتتوقف بأمان وتطلب المساعدة عن بعد. في السياسة C تُعالج الطلبات المشتركة في الحادث والتقاطع كمجموعة واحدة، ويفرج عنها تفويض واحد على مستوى التقاطع، وتظل كل مركبة تطبق فحوصها الخاصة.',
  'tour.emergency.t': '02 مركبة طوارئ',
  'tour.emergency.b': 'تُرسل سيارة إسعاف. لا تتنحى المركبة التي أمامها إلا إذا اجتاز فحص الفجوة الخاص بها؛ وإن تعذر ذلك يُسجل السبب بدلاً من إجبارها. في السياسة C تمنح الإشارات القادمة سيارة الإسعاف الأولوية.',
  'tour.roadworks.t': '05 أعمال طرق',
  'tour.roadworks.b': 'يوقّع مقاول إغلاق مسرب مخططاً. تتحقق عقدة التنسيق من تصريح المقاول وتوقيته وتعيد نشر الإغلاق قبل وضع الأقماع، فتندمج المركبات المتصلة مبكراً. ثم يُوسَّع الإغلاق ليشمل المقطع كله وتُحوَّل الحركة حوله.',
  'tour.security.t': 'رسائل لا ينبغي تصديقها',
  'tour.security.b': 'تُبث رسائل مصطنعة: معدّلة أثناء النقل، أو من مرسل غير معروف، أو خارج تصريح المقاول، أو مُعاد بثها بعد دقائق. ترفض العقدة وكل مركبة مستقبِلة كل واحدة منها بقاعدة محددة. يثبت التوقيع الصحيح هوية المرسل لا صحة المحتوى، وتبقى السلطة النهائية للمركبة.',
  'tour.evidence.t': 'المقارنة مع عدم اليقين فيها',
  'tour.evidence.b': 'البذور والطلب والمحفزات نفسها في السياسات A وB وC، مع استبعادات تعطّل ميزة تنسيق واحدة في كل مرة. يُعرض كل فرق مع مجال الثقة 95%، بما في ذلك الحالات التي لا يفيد فيها التنسيق.',
  'tour.about.t': 'ما هذا، وما ليس هو',
  'tour.about.b': 'البنية والخدمات وراء كل سيناريو، وما هو محاكى لا مقيس، وخارطة الطريق. نموذج طلابي مستقل على حي اصطناعي، دون أنظمة أو بيانات أو اعتماد من هيئة الطرق والمواصلات.',
  'tour.done.t': 'نهاية الجولة',
  'tour.done.b': 'يمكن إعادة تشغيل كل ما عُرض: اختر سيناريو من اليسار، أو بدّل السياسة، أو اختر أي مركبة أو حادث.',
  'list.sep': '، ',
  'why.signal_outage': 'انقطاع الإشارات',
  'why.restriction': 'قيد على الطريق',
  'why.corridor': 'ممر طوارئ',
  'why.restriction_lifted': 'رُفع القيد',
  'why.closure_seen': 'رؤية الإغلاق',
  'why.off_route': 'خرجت عن مسارها',
  'why.turn': 'مسرب الانعطاف',
  'why.closure': 'إغلاق أمامها',
  'why.speed': 'مسرب أسرع',
  'why.clear_lane': 'مسرب أكثر خلواً',
  'why.pull_over': 'الاقتراب من الرصيف عند موقع البلاغ',
  'why.v2x': 'تحذير V2X',
  'why.perception': 'حساساتها الخاصة',
  'why.remote_assistance': 'المساعدة عن بعد',
  'why.signals_restored': 'عودة الإشارات',
  'why.odd_uncontrolled_junction': 'خارج نطاق التشغيل',
  'place.hospital': 'مدخل مستشفى الحي (طريق الغرب)',
  'place.scene': 'بلاغ طبي، الشارع الجنوبي شرقاً',
  'res.individual': 'تفويض فردي من مشغل',
  'res.covered': 'مشمول بتفويض التقاطع {msg}',
  'res.junction': 'تفويض على مستوى التقاطع {msg}',
  'res.left': 'غادرت المركبة الحي',
  'res.released': 'أُفرج عنها',
  'res.restored': 'عادت الإشارات قبل أن يتفرغ مشغل',
  'exc.open': 'بانتظار',
  'exc.in_progress': 'لدى مشغل',
  'exc.resolved': 'محلول',
  'exc.auto_resolved': 'مشمول بتفويض',
  'exc.withdrawn': 'مسحوب',
  'op.individual': 'فردي',
  'op.group': 'جماعي',
  'ev.kind.individual': 'طلباً فردياً',
  'ev.kind.group': 'مجموعة طلبات',
  'chk.structure': 'البنية',
  'chk.replay_duplicate': 'إعادة البث / التكرار',
  'chk.map_version': 'إصدار الخريطة',
  'chk.issuer': 'المُصدِر',
  'chk.signature': 'التوقيع',
  'chk.permission': 'الصلاحية',
  'chk.location': 'الموقع',
  'chk.location_and_scope': 'الموقع والنطاق',
  'chk.scope': 'النطاق',
  'chk.freshness': 'الحداثة',
  'chk.validity': 'مدة الصلاحية',
  'chk.time': 'الوقت',
  'chk.version': 'الإصدار',
  'chk.origin': 'المصدر',
  'incT.signal_outage': 'انقطاع الإشارات في {area}',
  'incT.roadworks': 'أعمال طرق على {road}',
  'incT.emergency_corridor': 'ممر طوارئ لـ {ev}',
  'incC.signal_outage': 'توقفت وحدات التحكم في {area} عن الإبلاغ (انقطاع الطاقة)',
  'incC.roadworks': 'أعمال مخططة للمقاول {issuer} على {road} ({link})',
  'incC.emergency_corridor': 'طلب إرسال من EMS-DISPATCH: {ev} من {from} إلى {to}',
  'eng.title': 'المفتش الهندسي',
  'eng.lede': 'الحالة الخام للجلسة الجارية، والوصفة التي تعيد إنتاجها، وتصدير كل ما تعرضه الواجهة. تُقرأ القيم مباشرة من المحاكاة.',
  'eng.vehiclesShort': 'مركبة',
  'eng.gfx': 'الرسوميات',
  'eng.recipe': 'وصفة التشغيل',
  'eng.recipeSub': 'البذرة والإعداد والتدخلات نفسها تعيد إنتاج هذا التشغيل بدقة.',
  'eng.seed': 'البذرة',
  'eng.policy': 'السياسة وميزات التنسيق',
  'eng.density': 'الطلب',
  'eng.warmup': 'الإحماء',
  'eng.odd': 'أعرض مدخل تعبره مركبة ذاتية عند تقاطع مطفأ (مسارب)',
  'eng.map': 'إصدار الخريطة',
  'eng.operators': 'مشغلو المساعدة عن بعد',
  'eng.detection': 'تأخر اكتشاف الانقطاع',
  'eng.radio': 'نموذج الاتصال اللاسلكي',
  'eng.interventions': 'التدخلات على الخط الزمني',
  'eng.noInterventions': 'لا شيء بعد: هذا التشغيل هو الخط الأساسي.',
  'eng.exports': 'التصدير',
  'eng.exportsSub': 'تُبنى في المتصفح من الحالة الحالية للتشغيل.',
  'eng.exp.run': 'التشغيل (JSON)',
  'eng.exp.trips': 'الرحلات (CSV)',
  'eng.exp.messages': 'الرسائل (CSV)',
  'eng.exp.exceptions': 'الاستثناءات (CSV)',
  'eng.exp.events': 'الأحداث (CSV)',
  'eng.exp.vehicles': 'المركبات الآن (CSV)',
  'eng.reasons': 'رموز أسباب التحقق',
  'eng.vehicles': 'المركبات',
  'eng.f.stopped': 'متوقفة',
  'eng.f.mrc': 'أدنى المخاطر',
  'eng.f.connected': 'متصلة',
  'eng.f.all': 'الكل',
  'eng.col.vehicle': 'المركبة',
  'eng.col.segment': 'المقطع',
  'eng.col.speed': 'كم/س',
  'eng.col.mode': 'الوضع',
  'eng.col.binding': 'القيد الحاكم',
  'eng.col.junction': 'التقاطع',
  'eng.col.phase': 'الطور',
  'eng.col.interval': 'الفترة',
  'eng.col.remaining': 'المتبقي',
  'eng.col.time': 'الوقت',
  'eng.col.message': 'الرسالة',
  'eng.col.type': 'النوع',
  'eng.col.issuer': 'المُصدِر',
  'eng.col.verdict': 'حكم العقدة',
  'eng.col.id': 'المعرّف',
  'eng.col.status': 'الحالة',
  'eng.col.resolution': 'الحل',
  'eng.vehiclesNote': 'يُعرض {n} من {total}. اختر صفاً لفحص تلك المركبة في التوأم.',
  'eng.openVehicle': 'فحص {tag} في التوأم الرقمي',
  'eng.live.pause': 'إيقاف التحديث المباشر مؤقتاً',
  'eng.live.resume': 'استئناف التحديث المباشر',
  'eng.live.paused': 'التحديث المباشر متوقف مؤقتاً',
  'eng.signals': 'الإشارات',
  'eng.dark': 'مطفأة (توقف من جميع الاتجاهات)',
  'eng.preempt': 'أولوية',
  'eng.closures': 'الإغلاقات على الطريق',
  'eng.lanes': 'المسارب',
  'eng.none': 'لا شيء.',
  'eng.messages': 'سجل الرسائل',
  'eng.messagesSub': '{n} رسالة في هذا التشغيل، الأحدث أولاً (تُعرض 60).',
  'eng.exceptions': 'الاستثناءات',
  'eng.limits': 'القيود المعروفة',
  'rc.ACCEPTED': 'اجتازت كل الفحوص؛ تُطبق قيداً في التخطيط.',
  'rc.SCHEMA_INVALID': 'حقول مطلوبة مفقودة أو من نوع خاطئ.',
  'rc.DUPLICATE': 'عولجت من قبل؛ تُتجاهل وليست خطأً.',
  'rc.MAP_VERSION_MISMATCH': 'تشير إلى إصدار خريطة غير الذي يستخدمه المستقبِل.',
  'rc.UNKNOWN_ISSUER': 'المرسل ليس في مخزن الثقة.',
  'rc.CERT_EXPIRED': 'شهادة المرسل غير صالحة في هذا الوقت.',
  'rc.BAD_SIGNATURE': 'التوقيع لا يتحقق بمفتاح المُصدِر المزعوم.',
  'rc.NOT_PERMITTED': 'لا يحق للمُصدِر إرسال هذا النوع من الرسائل.',
  'rc.UNKNOWN_LOCATION': 'الموقع ليس على الخريطة أو خارج الطريق المشار إليه.',
  'rc.OUT_OF_SCOPE': 'الموقع خارج المنطقة المسموح بها للمُصدِر.',
  'rc.FUTURE_TIMESTAMP': 'صدرت في المستقبل بأكثر من فرق الساعة المسموح.',
  'rc.NOT_YET_VALID': 'تسري بعد مدة بعيدة بشكل غير معقول.',
  'rc.EXPIRED': 'انتهت مدة صلاحيتها.',
  'rc.STALE': 'أقدم من العمر الأقصى لنوعها، كإعادة بث مثلاً.',
  'rc.OUTDATED_VERSION': 'أقدم من الإصدار الذي يحمله المستقبِل.',
  'rc.CONFLICTING_UPDATE': 'الإصدار نفسه بمحتوى مختلف: يُؤشَّر عليها ولا تُطبق.',
  'lim.district': 'الحي والطرق والطلب وخطط الإشارات اصطناعية ومستوحاة من دبي. لم يُعايَر شيء على أعداد حركة أو شوارع حقيقية.',
  'lim.behaviour': 'تستخدم المركبات نموذج IDM لتتبع المركبات وMOBIL لتغيير المسارب مع منطق تقاطعات قائم على القواعد. لا يوجد مشاة أو دراجات أو مواقف حافلات أو مناورات وقوف أو أخطاء سائقين.',
  'lim.works': 'تعمل الإغلاقات على المسارب على امتداد مقطع الطريق. يُسمح بمرور المركبات الموجودة داخل منطقة العمل عند إقامتها، ولا تبدأ مناطق العمل داخل تقاطع.',
  'lim.radio': 'تُسحب زمن الاستجابة والفقد لكل توصيل في قناة الاتصال، مع مدى ثابت لوحدات جانب الطريق. لا يُنمذج الانتشار أو التداخل أو ازدحام القناة.',
  'lim.keys': 'يستخدم التوقيع ECDSA P-256 حقيقياً بمفاتيح تجريبية مشتقة من تسميات ثابتة. لا توجد بنية مفاتيح عامة ولا إلغاء شهادات ولا تدوير مفاتيح، ومخزن الثقة ثابت.',
  'lim.assist': 'للمساعدة عن بعد مشغلان بأزمنة معالجة ثابتة. قبول الأسطول لتفويض على مستوى التقاطع (السياسة C) افتراض قيد الاختبار وليس اتفاقاً مع مشغل.',
  'lim.benchmark': 'تستخدم المقارنة 10 بذور بمستوى طلب واحد. وهي استكشافية لا تقييماً تأكيدياً، ويُعرّف تأخير الإسعاف فقط للتشغيلات التي وصل فيها.',
  'lim.ev': 'مركبة طوارئ واحدة في كل مرة. وتُبسّط أولوية الإشارات إلى أصفر ثم أحمر شامل ثم أخضر لمدخلها.',
  'lim.render': 'تستوفي الصورة بين خطوات المحاكاة البالغة 0.1 ث. وطبقات المعلومات (النبضات والمناطق وشريط الممر) توضيحية.',
  'ab.lede': 'المارشال الرقمي مفهوم لبنية تحتية حضرية تمنح المركبات ذاتية القيادة معلومات موثوقة وحديثة ومحددة الموقع أثناء الظروف غير الاعتيادية على الطرق، وتنسق استثناءات الأسطول عندما يتأثر كثير من المركبات بالحدث نفسه. قد يكون المشغل على المدى البعيد هيئة نقل. يحاكي هذا النموذج تلك البنية ولا يرتبط بأي أنظمة تشغيلية.',
  'ab.visual': 'المدينة ثلاثية الأبعاد',
  'ab.visual.1': 'المباني والمستشفى والمركز التجاري والمعالم والنخيل وأعمدة الإنارة والمقاعد مأخوذة من مجموعة أصول Encirra: نماذج أصلية أنشأها فريق Team Kanban إجرائيًا بنصوص Blender الخاصة به. لا توجد نماذج أو خامات أو صور بيئة من أطراف ثالثة.',
  'ab.visual.2': 'المركبات والأشجار والأرض والبحر والسماء إجرائية أيضًا، يولّدها كود هذا المشروع داخل المتصفح.',
  'ab.visual.3': 'الإضاءة (منتصف النهار، الساعة الذهبية، الغسق، الليل) للعرض فقط: المحاكاة وكل النتائج واحدة تحت أي إضاءة.',
  'ab.visual.4': 'الحي وحده هو ما تجري محاكاته. أما المدينة المحيطة به (شوارعها ومبانيها وحركة المرور في الخلفية) فمشهد مولَّد، مُتخيَّل كالحي نفسه.',
  'ab.question': 'سؤال البحث',
  'ab.questionText': 'هل يمكن للتنسيق على مستوى الحادث أن يقلل العرقلة على مستوى الأسطول وعبء الاستثناءات أثناء اضطرابات الحركة المشتركة، مقارنة باستجابات المركبات الذاتية المستقلة، دون تجاوز قيود السلامة على متنها؟',
  'ab.questionNote': 'هذه فرضية قيد الاختبار وليست ادعاءً بالجدة. فرسائل الحوادث إلى المركبات المتصلة (مثل إشعارات الأحداث اللامركزية ورسائل معلومات المسافرين) موجودة بالفعل؛ والسؤال هنا هو هل يضيف تنسيق استجابة الأسطول قيمة قابلة للقياس.',
  'ab.scenarios': 'السيناريوهات',
  'ab.s1': '01 انقطاع إشارات المرور',
  'ab.s1d': 'تتعطل إشارات التقاطعات؛ تطبق المركبات قواعدها الخاصة بالإشارات المطفأة؛ ويشارك النظام الانقطاع وينسق الاستثناءات.',
  'ab.s2': '02 أولوية مركبات الطوارئ',
  'ab.s2d': 'تعبر سيارة إسعاف الحي؛ تقيّم المركبات إفساح الطريق بأمان؛ ويُبلّغ عن الحالات المتعذرة دون فرضها.',
  'ab.s5': '05 أعمال الطرق المؤقتة',
  'ab.s5d': 'تُنشر إغلاقات المسارب والمقاطع وتُتحقق صحتها ويُلتف حولها، بما في ذلك التحديثات القديمة وغير الصالحة.',
  'ab.arch': 'البنية المنطقية',
  'ab.archSub': 'نواة واحدة لمعلومات الحوادث والتنسيق تتشاركها السيناريوهات الثلاثة',
  'ab.d.infra': 'البنية التحتية والمُصدِرون (محاكاة)',
  'ab.d.core': 'نواة المارشال الرقمي',
  'ab.d.vehicles': 'المركبات (سلطة الحركة النهائية تبقى على متنها)',
  'ab.b.signals': 'وحدات التحكم بالإشارات',
  'ab.b.signals.s': 'نبض الحالة، حالة الطور',
  'ab.b.works': 'مقاولو الأعمال',
  'ab.b.works.s': 'إغلاقات مخططة موقعة',
  'ab.b.dispatch': 'إرسال الطوارئ',
  'ab.b.dispatch.s': 'طلبات الممرات',
  'ab.b.desk': 'مكتب المساعدة عن بعد',
  'ab.b.desk.s': 'سعة مشغلين محدودة',
  'ab.b.incident': 'إدارة الحوادث',
  'ab.b.incident.s': 'معرّفات ثابتة، دورة حياة، إصدارات',
  'ab.b.trust': 'الثقة والتحقق',
  'ab.b.trust.s': 'ECDSA P-256، النطاق، الحداثة',
  'ab.b.state': 'إدارة حالة الطرق',
  'ab.b.state.s': 'قيود، انقطاعات، ممرات',
  'ab.b.exceptions': 'تنسيق الاستثناءات',
  'ab.b.exceptions.s': 'تجميع، أولوية WSPT، سعة',
  'ab.b.v2x': 'خدمة رسائل V2X',
  'ab.b.v2x.s': 'تأخر، فقد، تغطية (محاكاة)',
  'ab.b.measure': 'التجارب والقياس',
  'ab.b.measure.s': 'تشغيلات متطابقة، تعريفات المقاييس',
  'ab.b.adapter': 'مهايئ المركبة',
  'ab.b.adapter.s': 'رسالة مقبولة -> قيود',
  'ab.b.planner': 'مخطط المركبة الذاتية وطبقة السلامة',
  'ab.b.planner.s': 'IDM، فحوص الفجوات، قواعد النطاق',
  'ab.b.twin': 'عارض التوأم (هذه الصفحة)',
  'ab.b.twin.s': 'يرسم حالة المحاكاة فقط',
  'ab.a.outage': 'انقطاع',
  'ab.a.submit': 'تقديم',
  'ab.a.request': 'طلب',
  'ab.a.tasks': 'مهام',
  'ab.a.signed': 'رسائل موقعة',
  'ab.a.exceptions': 'استثناءات',
  'ab.real': 'ما هو حقيقي هنا',
  'ab.real.1': 'محاكاة حركة مرور مجهرية حتمية (تتبع المركبات وتغيير المسارب والإشارات) تقود كل مركبة على الشاشة.',
  'ab.real.2': 'توقيع الرسائل والتحقق منها بشيفرة ECDSA P-256 مدققة؛ وتُرفض الرسائل المرفوضة بقاعدة محددة.',
  'ab.real.3': 'مقاييس محسوبة من تشغيلات مسجلة ببذور ثابتة، قابلة لإعادة التشغيل في المتصفح والتصدير بصيغتي CSV وJSON.',
  'ab.sim': 'ما هو محاكى أو مفترض',
  'ab.sim.1': 'الحي والطرق والطلب وخطط الإشارات اصطناعية ومستوحاة من دبي، وليست شوارع حقيقية.',
  'ab.sim.2': 'النقل اللاسلكي منمذج (تأخر وفقد وتغطية)، وليس انتشاراً مقيساً.',
  'ab.sim.3': 'سعة المساعدة عن بعد وأزمنة المعالجة وحدود تشغيل المركبات الذاتية افتراضات معلنة.',
  'ab.not': 'ما لا يُدّعى',
  'ab.not.1': 'لا اعتماد ولا وصول إلى بيانات ولا ارتباط بهيئة الطرق والمواصلات؛ نموذج طلابي مستقل.',
  'ab.not.2': 'لا سلوك معتمد من المستوى الرابع (SAE)؛ منطق المركبة الذاتية مخطط محاكى في نطاق محدد.',
  'ab.not.3': 'لا تحقق أو معايرة في العالم الحقيقي ولا دلالة إحصائية تتجاوز ما تُظهره التشغيلات.',
  'ab.roadmap': 'خارطة الطريق',
  'ab.now': 'الآن',
  'ab.next': 'التالي',
  'ab.later': 'لاحقاً',
  'ab.now.1': 'توأم تفاعلي لحي اصطناعي بثلاثة سيناريوهات على نواة تنسيق واحدة، مع وضع تحكيم إرشادي.',
  'ab.now.2': 'مقارنة A/B/C استكشافية مع استبعادات ومجالات ثقة 95% وإعادة تشغيل في المتصفح.',
  'ab.now.3': 'دراسة توجيه الممر السابقة محفوظة مع تحققها المتقاطع في SUMO.',
  'ab.next.1': 'بروتوكول تأكيدي يُجمَّد قبل أي تشغيل: بذور ومستويات طلب أكثر ومقياس أساسي معلن.',
  'ab.next.2': 'تشغيلات أعلى دقة للسيناريوهات نفسها في SUMO تُعاد في التوأم.',
  'ab.next.3': 'مراجعة بشرية مستقلة لخوارزمية التنسيق والمقاييس ونموذج الأمن.',
  'ab.later.1': 'ملفات رسائل متوافقة مع المعايير وإدارة شهادات بدلاً من المفاتيح التجريبية.',
  'ab.later.2': 'تصميم تجربة ميدانية مع مشغل، تخضع لحالة سلامة وموافقات خاصة بها.',
};

export const DICTS = { en, ar } as const;
export type Lang = keyof typeof DICTS;

export function fmt(s: string, params?: Record<string, string | number>): string {
  if (!params) return s;
  return s.replace(/\{(\w+)\}/g, (m, k: string) => (params[k] !== undefined ? String(params[k]) : m));
}

/** Whether a key exists (for recorded values that may or may not have a translation). */
export function hasKey(key: string): key is I18nKey {
  return Object.prototype.hasOwnProperty.call(en, key);
}

export function translate(lang: Lang, key: I18nKey, params?: Record<string, string | number>): string {
  const d = DICTS[lang] as Record<I18nKey, string>;
  return fmt(d[key] ?? en[key] ?? key, params);
}

export function useT() {
  const lang = useStore((s) => s.lang);
  return (key: I18nKey, params?: Record<string, string | number>) => translate(lang, key, params);
}
